import { c as zc, a as D } from "./utils-A5nzBcJc.js";
import { jsx as d, jsxs as H, Fragment as Ae } from "react/jsx-runtime";
import * as c from "react";
import Z, { forwardRef as jc, createElement as $o, useLayoutEffect as Yc, useState as Xc } from "react";
import * as zt from "react-dom";
import qc from "react-dom";
const Fo = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Bo = zc, Zc = (e, t) => (n) => {
  var o;
  if ((t == null ? void 0 : t.variants) == null) return Bo(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: r, defaultVariants: a } = t, i = Object.keys(r).map((u) => {
    const p = n == null ? void 0 : n[u], f = a == null ? void 0 : a[u];
    if (p === null) return null;
    const m = Fo(p) || Fo(f);
    return r[u][m];
  }), s = n && Object.entries(n).reduce((u, p) => {
    let [f, m] = p;
    return m === void 0 || (u[f] = m), u;
  }, {}), l = t == null || (o = t.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((u, p) => {
    let { class: f, className: m, ...v } = p;
    return Object.entries(v).every((w) => {
      let [h, g] = w;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...s
      }[h]) : {
        ...a,
        ...s
      }[h] === g;
    }) ? [
      ...u,
      f,
      m
    ] : u;
  }, []);
  return Bo(e, i, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Qc = Zc(
  "relative w-full rounded-lg border px-4 py-3 text-sm [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg]:text-foreground [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        default: "bg-background text-foreground",
        destructive: "border-destructive/50 text-destructive [&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), Jc = c.forwardRef(({ className: e, variant: t, ...n }, o) => /* @__PURE__ */ d(
  "div",
  {
    ref: o,
    role: "alert",
    className: D(Qc({ variant: t }), e),
    ...n
  }
));
Jc.displayName = "Alert";
const el = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "h5",
  {
    ref: n,
    className: D("mb-1 font-medium leading-none tracking-tight", e),
    ...t
  }
));
el.displayName = "AlertTitle";
const tl = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    className: D("text-sm [&_p]:leading-relaxed", e),
    ...t
  }
));
tl.displayName = "AlertDescription";
const nl = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    className: D(
      "rounded-xl border bg-white text-card-foreground shadow",
      e
    ),
    ...t
  }
));
nl.displayName = "Card";
const ol = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    className: D("flex flex-col space-y-1.5 p-6", e),
    ...t
  }
));
ol.displayName = "CardHeader";
const rl = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "h3",
  {
    ref: n,
    className: D("font-semibold leading-none tracking-tight", e),
    ...t
  }
));
rl.displayName = "CardTitle";
const al = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "p",
  {
    ref: n,
    className: D("text-sm text-muted-foreground", e),
    ...t
  }
));
al.displayName = "CardDescription";
const il = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d("div", { ref: n, className: D("p-6 pt-0", e), ...t }));
il.displayName = "CardContent";
const sl = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    className: D("flex items-center p-6 pt-0", e),
    ...t
  }
));
sl.displayName = "CardFooter";
function E(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (e == null || e(r), n === !1 || !r.defaultPrevented)
      return t == null ? void 0 : t(r);
  };
}
function Vo(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function pt(...e) {
  return (t) => {
    let n = !1;
    const o = e.map((r) => {
      const a = Vo(r, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < o.length; r++) {
          const a = o[r];
          typeof a == "function" ? a() : Vo(e[r], null);
        }
      };
  };
}
function $(...e) {
  return c.useCallback(pt(...e), e);
}
function cl(e, t) {
  const n = c.createContext(t), o = (a) => {
    const { children: i, ...s } = a, l = c.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ d(n.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function r(a) {
    const i = c.useContext(n);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [o, r];
}
function ee(e, t = []) {
  let n = [];
  function o(a, i) {
    const s = c.createContext(i), l = n.length;
    n = [...n, i];
    const u = (f) => {
      var b;
      const { scope: m, children: v, ...w } = f, h = ((b = m == null ? void 0 : m[e]) == null ? void 0 : b[l]) || s, g = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ d(h.Provider, { value: g, children: v });
    };
    u.displayName = a + "Provider";
    function p(f, m) {
      var h;
      const v = ((h = m == null ? void 0 : m[e]) == null ? void 0 : h[l]) || s, w = c.useContext(v);
      if (w) return w;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, p];
  }
  const r = () => {
    const a = n.map((i) => c.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return r.scopeName = e, [o, ll(r, ...t)];
}
function ll(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(a)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var J = globalThis != null && globalThis.document ? c.useLayoutEffect : () => {
}, ul = c[" useInsertionEffect ".trim().toString()] || J;
function ae({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: o
}) {
  const [r, a, i] = dl({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : r;
  {
    const p = c.useRef(e !== void 0);
    c.useEffect(() => {
      const f = p.current;
      f !== s && console.warn(
        `${o} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), p.current = s;
    }, [s, o]);
  }
  const u = c.useCallback(
    (p) => {
      var f;
      if (s) {
        const m = fl(p) ? p(e) : p;
        m !== e && ((f = i.current) == null || f.call(i, m));
      } else
        a(p);
    },
    [s, e, a, i]
  );
  return [l, u];
}
function dl({
  defaultProp: e,
  onChange: t
}) {
  const [n, o] = c.useState(e), r = c.useRef(n), a = c.useRef(t);
  return ul(() => {
    a.current = t;
  }, [t]), c.useEffect(() => {
    var i;
    r.current !== n && ((i = a.current) == null || i.call(a, n), r.current = n);
  }, [n, r]), [n, o, a];
}
function fl(e) {
  return typeof e == "function";
}
function mt(e) {
  const t = c.useRef({ value: e, previous: e });
  return c.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function ht(e) {
  const [t, n] = c.useState(void 0);
  return J(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let i, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          i = u.inlineSize, s = u.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        n({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
// @__NO_SIDE_EFFECTS__
function Xe(e) {
  const t = /* @__PURE__ */ pl(e), n = c.forwardRef((o, r) => {
    const { children: a, ...i } = o, s = c.Children.toArray(a), l = s.find(hl);
    if (l) {
      const u = l.props.children, p = s.map((f) => f === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ d(t, { ...i, ref: r, children: c.isValidElement(u) ? c.cloneElement(u, void 0, p) : null });
    }
    return /* @__PURE__ */ d(t, { ...i, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function pl(e) {
  const t = c.forwardRef((n, o) => {
    const { children: r, ...a } = n;
    if (c.isValidElement(r)) {
      const i = gl(r), s = vl(a, r.props);
      return r.type !== c.Fragment && (s.ref = o ? pt(o, i) : i), c.cloneElement(r, s);
    }
    return c.Children.count(r) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var ml = Symbol("radix.slottable");
function hl(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === ml;
}
function vl(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...s) => {
      const l = a(...s);
      return r(...s), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function gl(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var wl = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], _ = wl.reduce((e, t) => {
  const n = /* @__PURE__ */ Xe(`Primitive.${t}`), o = c.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, l = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...s, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function hr(e, t) {
  e && zt.flushSync(() => e.dispatchEvent(t));
}
var jt = "Switch", [bl] = ee(jt), [yl, Sl] = bl(jt), vr = c.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      form: p,
      ...f
    } = e, [m, v] = c.useState(null), w = $(t, (S) => v(S)), h = c.useRef(!1), g = m ? p || !!m.closest("form") : !0, [b, y] = ae({
      prop: r,
      defaultProp: a ?? !1,
      onChange: u,
      caller: jt
    });
    return /* @__PURE__ */ H(yl, { scope: n, checked: b, disabled: s, children: [
      /* @__PURE__ */ d(
        _.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": i,
          "data-state": yr(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...f,
          ref: w,
          onClick: E(e.onClick, (S) => {
            y((x) => !x), g && (h.current = S.isPropagationStopped(), h.current || S.stopPropagation());
          })
        }
      ),
      g && /* @__PURE__ */ d(
        br,
        {
          control: m,
          bubbles: !h.current,
          name: o,
          value: l,
          checked: b,
          required: i,
          disabled: s,
          form: p,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
vr.displayName = jt;
var gr = "SwitchThumb", wr = c.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...o } = e, r = Sl(gr, n);
    return /* @__PURE__ */ d(
      _.span,
      {
        "data-state": yr(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
wr.displayName = gr;
var xl = "SwitchBubbleInput", br = c.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const i = c.useRef(null), s = $(i, a), l = mt(n), u = ht(t);
    return c.useEffect(() => {
      const p = i.current;
      if (!p) return;
      const f = window.HTMLInputElement.prototype, v = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && v) {
        const w = new Event("click", { bubbles: o });
        v.call(p, n), p.dispatchEvent(w);
      }
    }, [l, n, o]), /* @__PURE__ */ d(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...u,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
br.displayName = xl;
function yr(e) {
  return e ? "checked" : "unchecked";
}
var Sr = vr, Cl = wr;
const Rl = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Sr,
  {
    className: D(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input",
      e
    ),
    ...t,
    ref: n,
    children: /* @__PURE__ */ d(
      Cl,
      {
        className: D(
          "pointer-events-none block h-4 w-4 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-4 data-[state=unchecked]:translate-x-0"
        )
      }
    )
  }
));
Rl.displayName = Sr.displayName;
function El(e, t) {
  return c.useReducer((n, o) => t[n][o] ?? n, e);
}
var te = (e) => {
  const { present: t, children: n } = e, o = Pl(t), r = typeof n == "function" ? n({ present: o.isPresent }) : c.Children.only(n), a = $(o.ref, Nl(r));
  return typeof n == "function" || o.isPresent ? c.cloneElement(r, { ref: a }) : null;
};
te.displayName = "Presence";
function Pl(e) {
  const [t, n] = c.useState(), o = c.useRef(null), r = c.useRef(e), a = c.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = El(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return c.useEffect(() => {
    const u = Rt(o.current);
    a.current = s === "mounted" ? u : "none";
  }, [s]), J(() => {
    const u = o.current, p = r.current;
    if (p !== e) {
      const m = a.current, v = Rt(u);
      e ? l("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(p && m !== v ? "ANIMATION_OUT" : "UNMOUNT"), r.current = e;
    }
  }, [e, l]), J(() => {
    if (t) {
      let u;
      const p = t.ownerDocument.defaultView ?? window, f = (v) => {
        const h = Rt(o.current).includes(CSS.escape(v.animationName));
        if (v.target === t && h && (l("ANIMATION_END"), !r.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", u = p.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, m = (v) => {
        v.target === t && (a.current = Rt(o.current));
      };
      return t.addEventListener("animationstart", m), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        p.clearTimeout(u), t.removeEventListener("animationstart", m), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: c.useCallback((u) => {
      o.current = u ? getComputedStyle(u) : null, n(u);
    }, [])
  };
}
function Rt(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Nl(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Q(e) {
  const t = c.useRef(e);
  return c.useEffect(() => {
    t.current = e;
  }), c.useMemo(() => (...n) => {
    var o;
    return (o = t.current) == null ? void 0 : o.call(t, ...n);
  }, []);
}
var Al = c.createContext(void 0);
function ke(e) {
  const t = c.useContext(Al);
  return e || t || "ltr";
}
function ct(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function _l(e, t) {
  return c.useReducer((n, o) => t[n][o] ?? n, e);
}
var Yn = "ScrollArea", [xr] = ee(Yn), [Ml, fe] = xr(Yn), Cr = c.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: n,
      type: o = "hover",
      dir: r,
      scrollHideDelay: a = 600,
      ...i
    } = e, [s, l] = c.useState(null), [u, p] = c.useState(null), [f, m] = c.useState(null), [v, w] = c.useState(null), [h, g] = c.useState(null), [b, y] = c.useState(0), [S, x] = c.useState(0), [C, P] = c.useState(!1), [R, A] = c.useState(!1), M = $(t, (O) => l(O)), T = ke(r);
    return /* @__PURE__ */ d(
      Ml,
      {
        scope: n,
        type: o,
        dir: T,
        scrollHideDelay: a,
        scrollArea: s,
        viewport: u,
        onViewportChange: p,
        content: f,
        onContentChange: m,
        scrollbarX: v,
        onScrollbarXChange: w,
        scrollbarXEnabled: C,
        onScrollbarXEnabledChange: P,
        scrollbarY: h,
        onScrollbarYChange: g,
        scrollbarYEnabled: R,
        onScrollbarYEnabledChange: A,
        onCornerWidthChange: y,
        onCornerHeightChange: x,
        children: /* @__PURE__ */ d(
          _.div,
          {
            dir: T,
            ...i,
            ref: M,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": b + "px",
              "--radix-scroll-area-corner-height": S + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Cr.displayName = Yn;
var Rr = "ScrollAreaViewport", Er = c.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, children: o, nonce: r, ...a } = e, i = fe(Rr, n), s = c.useRef(null), l = $(t, s, i.onViewportChange);
    return /* @__PURE__ */ H(Ae, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ d(
        _.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...a,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ d("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
Er.displayName = Rr;
var Re = "ScrollAreaScrollbar", Xn = c.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = fe(Re, e.__scopeScrollArea), { onScrollbarXEnabledChange: a, onScrollbarYEnabledChange: i } = r, s = e.orientation === "horizontal";
    return c.useEffect(() => (s ? a(!0) : i(!0), () => {
      s ? a(!1) : i(!1);
    }), [s, a, i]), r.type === "hover" ? /* @__PURE__ */ d(Tl, { ...o, ref: t, forceMount: n }) : r.type === "scroll" ? /* @__PURE__ */ d(Il, { ...o, ref: t, forceMount: n }) : r.type === "auto" ? /* @__PURE__ */ d(Pr, { ...o, ref: t, forceMount: n }) : r.type === "always" ? /* @__PURE__ */ d(qn, { ...o, ref: t }) : null;
  }
);
Xn.displayName = Re;
var Tl = c.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = fe(Re, e.__scopeScrollArea), [a, i] = c.useState(!1);
  return c.useEffect(() => {
    const s = r.scrollArea;
    let l = 0;
    if (s) {
      const u = () => {
        window.clearTimeout(l), i(!0);
      }, p = () => {
        l = window.setTimeout(() => i(!1), r.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", u), s.addEventListener("pointerleave", p), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", u), s.removeEventListener("pointerleave", p);
      };
    }
  }, [r.scrollArea, r.scrollHideDelay]), /* @__PURE__ */ d(te, { present: n || a, children: /* @__PURE__ */ d(
    Pr,
    {
      "data-state": a ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), Il = c.forwardRef((e, t) => {
  const { forceMount: n, ...o } = e, r = fe(Re, e.__scopeScrollArea), a = e.orientation === "horizontal", i = Xt(() => l("SCROLL_END"), 100), [s, l] = _l("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return c.useEffect(() => {
    if (s === "idle") {
      const u = window.setTimeout(() => l("HIDE"), r.scrollHideDelay);
      return () => window.clearTimeout(u);
    }
  }, [s, r.scrollHideDelay, l]), c.useEffect(() => {
    const u = r.viewport, p = a ? "scrollLeft" : "scrollTop";
    if (u) {
      let f = u[p];
      const m = () => {
        const v = u[p];
        f !== v && (l("SCROLL"), i()), f = v;
      };
      return u.addEventListener("scroll", m), () => u.removeEventListener("scroll", m);
    }
  }, [r.viewport, a, l, i]), /* @__PURE__ */ d(te, { present: n || s !== "hidden", children: /* @__PURE__ */ d(
    qn,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: E(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: E(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Pr = c.forwardRef((e, t) => {
  const n = fe(Re, e.__scopeScrollArea), { forceMount: o, ...r } = e, [a, i] = c.useState(!1), s = e.orientation === "horizontal", l = Xt(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, p = n.viewport.offsetHeight < n.viewport.scrollHeight;
      i(s ? u : p);
    }
  }, 10);
  return qe(n.viewport, l), qe(n.content, l), /* @__PURE__ */ d(te, { present: o || a, children: /* @__PURE__ */ d(
    qn,
    {
      "data-state": a ? "visible" : "hidden",
      ...r,
      ref: t
    }
  ) });
}), qn = c.forwardRef((e, t) => {
  const { orientation: n = "vertical", ...o } = e, r = fe(Re, e.__scopeScrollArea), a = c.useRef(null), i = c.useRef(0), [s, l] = c.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), u = Tr(s.viewport, s.content), p = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (m) => a.current = m,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (m) => i.current = m
  };
  function f(m, v) {
    return Fl(m, i.current, s, v);
  }
  return n === "horizontal" ? /* @__PURE__ */ d(
    Dl,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollLeft, v = Wo(m, s, r.dir);
          a.current.style.transform = `translate3d(${v}px, 0, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollLeft = f(m, r.dir));
      }
    }
  ) : n === "vertical" ? /* @__PURE__ */ d(
    Ol,
    {
      ...p,
      ref: t,
      onThumbPositionChange: () => {
        if (r.viewport && a.current) {
          const m = r.viewport.scrollTop, v = Wo(m, s);
          a.current.style.transform = `translate3d(0, ${v}px, 0)`;
        }
      },
      onWheelScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = m);
      },
      onDragScroll: (m) => {
        r.viewport && (r.viewport.scrollTop = f(m));
      }
    }
  ) : null;
}), Dl = c.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = fe(Re, e.__scopeScrollArea), [i, s] = c.useState(), l = c.useRef(null), u = $(t, l, a.onScrollbarXChange);
  return c.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ d(
    Ar,
    {
      "data-orientation": "horizontal",
      ...r,
      ref: u,
      sizes: n,
      style: {
        bottom: 0,
        left: a.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: a.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Yt(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.x),
      onDragScroll: (p) => e.onDragScroll(p.x),
      onWheelScroll: (p, f) => {
        if (a.viewport) {
          const m = a.viewport.scrollLeft + p.deltaX;
          e.onWheelScroll(m), Dr(m, f) && p.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && i && o({
          content: a.viewport.scrollWidth,
          viewport: a.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Ot(i.paddingLeft),
            paddingEnd: Ot(i.paddingRight)
          }
        });
      }
    }
  );
}), Ol = c.forwardRef((e, t) => {
  const { sizes: n, onSizesChange: o, ...r } = e, a = fe(Re, e.__scopeScrollArea), [i, s] = c.useState(), l = c.useRef(null), u = $(t, l, a.onScrollbarYChange);
  return c.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ d(
    Ar,
    {
      "data-orientation": "vertical",
      ...r,
      ref: u,
      sizes: n,
      style: {
        top: 0,
        right: a.dir === "ltr" ? 0 : void 0,
        left: a.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Yt(n) + "px",
        ...e.style
      },
      onThumbPointerDown: (p) => e.onThumbPointerDown(p.y),
      onDragScroll: (p) => e.onDragScroll(p.y),
      onWheelScroll: (p, f) => {
        if (a.viewport) {
          const m = a.viewport.scrollTop + p.deltaY;
          e.onWheelScroll(m), Dr(m, f) && p.preventDefault();
        }
      },
      onResize: () => {
        l.current && a.viewport && i && o({
          content: a.viewport.scrollHeight,
          viewport: a.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Ot(i.paddingTop),
            paddingEnd: Ot(i.paddingBottom)
          }
        });
      }
    }
  );
}), [kl, Nr] = xr(Re), Ar = c.forwardRef((e, t) => {
  const {
    __scopeScrollArea: n,
    sizes: o,
    hasThumb: r,
    onThumbChange: a,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: u,
    onWheelScroll: p,
    onResize: f,
    ...m
  } = e, v = fe(Re, n), [w, h] = c.useState(null), g = $(t, (M) => h(M)), b = c.useRef(null), y = c.useRef(""), S = v.viewport, x = o.content - o.viewport, C = Q(p), P = Q(l), R = Xt(f, 10);
  function A(M) {
    if (b.current) {
      const T = M.clientX - b.current.left, O = M.clientY - b.current.top;
      u({ x: T, y: O });
    }
  }
  return c.useEffect(() => {
    const M = (T) => {
      const O = T.target;
      (w == null ? void 0 : w.contains(O)) && C(T, x);
    };
    return document.addEventListener("wheel", M, { passive: !1 }), () => document.removeEventListener("wheel", M, { passive: !1 });
  }, [S, w, x, C]), c.useEffect(P, [o, P]), qe(w, R), qe(v.content, R), /* @__PURE__ */ d(
    kl,
    {
      scope: n,
      scrollbar: w,
      hasThumb: r,
      onThumbChange: Q(a),
      onThumbPointerUp: Q(i),
      onThumbPositionChange: P,
      onThumbPointerDown: Q(s),
      children: /* @__PURE__ */ d(
        _.div,
        {
          ...m,
          ref: g,
          style: { position: "absolute", ...m.style },
          onPointerDown: E(e.onPointerDown, (M) => {
            M.button === 0 && (M.target.setPointerCapture(M.pointerId), b.current = w.getBoundingClientRect(), y.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", v.viewport && (v.viewport.style.scrollBehavior = "auto"), A(M));
          }),
          onPointerMove: E(e.onPointerMove, A),
          onPointerUp: E(e.onPointerUp, (M) => {
            const T = M.target;
            T.hasPointerCapture(M.pointerId) && T.releasePointerCapture(M.pointerId), document.body.style.webkitUserSelect = y.current, v.viewport && (v.viewport.style.scrollBehavior = ""), b.current = null;
          })
        }
      )
    }
  );
}), Dt = "ScrollAreaThumb", _r = c.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = Nr(Dt, e.__scopeScrollArea);
    return /* @__PURE__ */ d(te, { present: n || r.hasThumb, children: /* @__PURE__ */ d(Ll, { ref: t, ...o }) });
  }
), Ll = c.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: n, style: o, ...r } = e, a = fe(Dt, n), i = Nr(Dt, n), { onThumbPositionChange: s } = i, l = $(
      t,
      (f) => i.onThumbChange(f)
    ), u = c.useRef(void 0), p = Xt(() => {
      u.current && (u.current(), u.current = void 0);
    }, 100);
    return c.useEffect(() => {
      const f = a.viewport;
      if (f) {
        const m = () => {
          if (p(), !u.current) {
            const v = Bl(f, s);
            u.current = v, s();
          }
        };
        return s(), f.addEventListener("scroll", m), () => f.removeEventListener("scroll", m);
      }
    }, [a.viewport, p, s]), /* @__PURE__ */ d(
      _.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...r,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: E(e.onPointerDownCapture, (f) => {
          const v = f.target.getBoundingClientRect(), w = f.clientX - v.left, h = f.clientY - v.top;
          i.onThumbPointerDown({ x: w, y: h });
        }),
        onPointerUp: E(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
_r.displayName = Dt;
var Zn = "ScrollAreaCorner", Mr = c.forwardRef(
  (e, t) => {
    const n = fe(Zn, e.__scopeScrollArea), o = !!(n.scrollbarX && n.scrollbarY);
    return n.type !== "scroll" && o ? /* @__PURE__ */ d($l, { ...e, ref: t }) : null;
  }
);
Mr.displayName = Zn;
var $l = c.forwardRef((e, t) => {
  const { __scopeScrollArea: n, ...o } = e, r = fe(Zn, n), [a, i] = c.useState(0), [s, l] = c.useState(0), u = !!(a && s);
  return qe(r.scrollbarX, () => {
    var f;
    const p = ((f = r.scrollbarX) == null ? void 0 : f.offsetHeight) || 0;
    r.onCornerHeightChange(p), l(p);
  }), qe(r.scrollbarY, () => {
    var f;
    const p = ((f = r.scrollbarY) == null ? void 0 : f.offsetWidth) || 0;
    r.onCornerWidthChange(p), i(p);
  }), u ? /* @__PURE__ */ d(
    _.div,
    {
      ...o,
      ref: t,
      style: {
        width: a,
        height: s,
        position: "absolute",
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Ot(e) {
  return e ? parseInt(e, 10) : 0;
}
function Tr(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function Yt(e) {
  const t = Tr(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - n) * t;
  return Math.max(o, 18);
}
function Fl(e, t, n, o = "ltr") {
  const r = Yt(n), a = r / 2, i = t || a, s = r - i, l = n.scrollbar.paddingStart + i, u = n.scrollbar.size - n.scrollbar.paddingEnd - s, p = n.content - n.viewport, f = o === "ltr" ? [0, p] : [p * -1, 0];
  return Ir([l, u], f)(e);
}
function Wo(e, t, n = "ltr") {
  const o = Yt(t), r = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, a = t.scrollbar.size - r, i = t.content - t.viewport, s = a - o, l = n === "ltr" ? [0, i] : [i * -1, 0], u = ct(e, l);
  return Ir([0, i], [0, s])(u);
}
function Ir(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function Dr(e, t) {
  return e > 0 && e < t;
}
var Bl = (e, t = () => {
}) => {
  let n = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function r() {
    const a = { left: e.scrollLeft, top: e.scrollTop }, i = n.left !== a.left, s = n.top !== a.top;
    (i || s) && t(), n = a, o = window.requestAnimationFrame(r);
  }(), () => window.cancelAnimationFrame(o);
};
function Xt(e, t) {
  const n = Q(e), o = c.useRef(0);
  return c.useEffect(() => () => window.clearTimeout(o.current), []), c.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(n, t);
  }, [n, t]);
}
function qe(e, t) {
  const n = Q(t);
  J(() => {
    let o = 0;
    if (e) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(n);
      });
      return r.observe(e), () => {
        window.cancelAnimationFrame(o), r.unobserve(e);
      };
    }
  }, [e, n]);
}
var Or = Cr, Vl = Er, Wl = Mr;
const Hl = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ H(
  Or,
  {
    ref: o,
    className: D("relative overflow-hidden", e),
    ...n,
    children: [
      /* @__PURE__ */ d(Vl, { className: "h-full w-full rounded-[inherit]", children: t }),
      /* @__PURE__ */ d(kr, {}),
      /* @__PURE__ */ d(Wl, {})
    ]
  }
));
Hl.displayName = Or.displayName;
const kr = c.forwardRef(({ className: e, orientation: t = "vertical", ...n }, o) => /* @__PURE__ */ d(
  Xn,
  {
    ref: o,
    orientation: t,
    className: D(
      "flex touch-none select-none transition-colors",
      t === "vertical" && "h-full w-2.5 border-l border-l-transparent p-[1px]",
      t === "horizontal" && "h-2.5 flex-col border-t border-t-transparent p-[1px]",
      e
    ),
    ...n,
    children: /* @__PURE__ */ d(_r, { className: "relative flex-1 rounded-full bg-border" })
  }
));
kr.displayName = Xn.displayName;
function vt(e) {
  const t = e + "CollectionProvider", [n, o] = ee(t), [r, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (h) => {
    const { scope: g, children: b } = h, y = Z.useRef(null), S = Z.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(r, { scope: g, itemMap: S, collectionRef: y, children: b });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ Xe(s), u = Z.forwardRef(
    (h, g) => {
      const { scope: b, children: y } = h, S = a(s, b), x = $(g, S.collectionRef);
      return /* @__PURE__ */ d(l, { ref: x, children: y });
    }
  );
  u.displayName = s;
  const p = e + "CollectionItemSlot", f = "data-radix-collection-item", m = /* @__PURE__ */ Xe(p), v = Z.forwardRef(
    (h, g) => {
      const { scope: b, children: y, ...S } = h, x = Z.useRef(null), C = $(g, x), P = a(p, b);
      return Z.useEffect(() => (P.itemMap.set(x, { ref: x, ...S }), () => void P.itemMap.delete(x))), /* @__PURE__ */ d(m, { [f]: "", ref: C, children: y });
    }
  );
  v.displayName = p;
  function w(h) {
    const g = a(e + "CollectionConsumer", h);
    return Z.useCallback(() => {
      const y = g.collectionRef.current;
      if (!y) return [];
      const S = Array.from(y.querySelectorAll(`[${f}]`));
      return Array.from(g.itemMap.values()).sort(
        (P, R) => S.indexOf(P.ref.current) - S.indexOf(R.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: i, Slot: u, ItemSlot: v },
    w,
    o
  ];
}
var Ul = c[" useId ".trim().toString()] || (() => {
}), Kl = 0;
function re(e) {
  const [t, n] = c.useState(Ul());
  return J(() => {
    n((o) => o ?? String(Kl++));
  }, [e]), t ? `radix-${t}` : "";
}
var xn = "rovingFocusGroup.onEntryFocus", Gl = { bubbles: !1, cancelable: !0 }, gt = "RovingFocusGroup", [In, Lr, zl] = vt(gt), [jl, Qe] = ee(
  gt,
  [zl]
), [Yl, Xl] = jl(gt), $r = c.forwardRef(
  (e, t) => /* @__PURE__ */ d(In.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(In.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(ql, { ...e, ref: t }) }) })
);
$r.displayName = gt;
var ql = c.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: o,
    loop: r = !1,
    dir: a,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: u,
    preventScrollOnEntryFocus: p = !1,
    ...f
  } = e, m = c.useRef(null), v = $(t, m), w = ke(a), [h, g] = ae({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: gt
  }), [b, y] = c.useState(!1), S = Q(u), x = Lr(n), C = c.useRef(!1), [P, R] = c.useState(0);
  return c.useEffect(() => {
    const A = m.current;
    if (A)
      return A.addEventListener(xn, S), () => A.removeEventListener(xn, S);
  }, [S]), /* @__PURE__ */ d(
    Yl,
    {
      scope: n,
      orientation: o,
      dir: w,
      loop: r,
      currentTabStopId: h,
      onItemFocus: c.useCallback(
        (A) => g(A),
        [g]
      ),
      onItemShiftTab: c.useCallback(() => y(!0), []),
      onFocusableItemAdd: c.useCallback(
        () => R((A) => A + 1),
        []
      ),
      onFocusableItemRemove: c.useCallback(
        () => R((A) => A - 1),
        []
      ),
      children: /* @__PURE__ */ d(
        _.div,
        {
          tabIndex: b || P === 0 ? -1 : 0,
          "data-orientation": o,
          ...f,
          ref: v,
          style: { outline: "none", ...e.style },
          onMouseDown: E(e.onMouseDown, () => {
            C.current = !0;
          }),
          onFocus: E(e.onFocus, (A) => {
            const M = !C.current;
            if (A.target === A.currentTarget && M && !b) {
              const T = new CustomEvent(xn, Gl);
              if (A.currentTarget.dispatchEvent(T), !T.defaultPrevented) {
                const O = x().filter((L) => L.focusable), F = O.find((L) => L.active), B = O.find((L) => L.id === h), U = [F, B, ...O].filter(
                  Boolean
                ).map((L) => L.ref.current);
                Vr(U, p);
              }
            }
            C.current = !1;
          }),
          onBlur: E(e.onBlur, () => y(!1))
        }
      )
    }
  );
}), Fr = "RovingFocusGroupItem", Br = c.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: o = !0,
      active: r = !1,
      tabStopId: a,
      children: i,
      ...s
    } = e, l = re(), u = a || l, p = Xl(Fr, n), f = p.currentTabStopId === u, m = Lr(n), { onFocusableItemAdd: v, onFocusableItemRemove: w, currentTabStopId: h } = p;
    return c.useEffect(() => {
      if (o)
        return v(), () => w();
    }, [o, v, w]), /* @__PURE__ */ d(
      In.ItemSlot,
      {
        scope: n,
        id: u,
        focusable: o,
        active: r,
        children: /* @__PURE__ */ d(
          _.span,
          {
            tabIndex: f ? 0 : -1,
            "data-orientation": p.orientation,
            ...s,
            ref: t,
            onMouseDown: E(e.onMouseDown, (g) => {
              o ? p.onItemFocus(u) : g.preventDefault();
            }),
            onFocus: E(e.onFocus, () => p.onItemFocus(u)),
            onKeyDown: E(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                p.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget) return;
              const b = Jl(g, p.orientation, p.dir);
              if (b !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey) return;
                g.preventDefault();
                let S = m().filter((x) => x.focusable).map((x) => x.ref.current);
                if (b === "last") S.reverse();
                else if (b === "prev" || b === "next") {
                  b === "prev" && S.reverse();
                  const x = S.indexOf(g.currentTarget);
                  S = p.loop ? eu(S, x + 1) : S.slice(x + 1);
                }
                setTimeout(() => Vr(S));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: f, hasTabStop: h != null }) : i
          }
        )
      }
    );
  }
);
Br.displayName = Fr;
var Zl = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function Ql(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function Jl(e, t, n) {
  const o = Ql(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return Zl[o];
}
function Vr(e, t = !1) {
  const n = document.activeElement;
  for (const o of e)
    if (o === n || (o.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function eu(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var Qn = $r, Jn = Br, eo = "Radio", [tu, Wr] = ee(eo), [nu, ou] = tu(eo), Hr = c.forwardRef(
  (e, t) => {
    const {
      __scopeRadio: n,
      name: o,
      checked: r = !1,
      required: a,
      disabled: i,
      value: s = "on",
      onCheck: l,
      form: u,
      ...p
    } = e, [f, m] = c.useState(null), v = $(t, (g) => m(g)), w = c.useRef(!1), h = f ? u || !!f.closest("form") : !0;
    return /* @__PURE__ */ H(nu, { scope: n, checked: r, disabled: i, children: [
      /* @__PURE__ */ d(
        _.button,
        {
          type: "button",
          role: "radio",
          "aria-checked": r,
          "data-state": zr(r),
          "data-disabled": i ? "" : void 0,
          disabled: i,
          value: s,
          ...p,
          ref: v,
          onClick: E(e.onClick, (g) => {
            r || l == null || l(), h && (w.current = g.isPropagationStopped(), w.current || g.stopPropagation());
          })
        }
      ),
      h && /* @__PURE__ */ d(
        Gr,
        {
          control: f,
          bubbles: !w.current,
          name: o,
          value: s,
          checked: r,
          required: a,
          disabled: i,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Hr.displayName = eo;
var Ur = "RadioIndicator", Kr = c.forwardRef(
  (e, t) => {
    const { __scopeRadio: n, forceMount: o, ...r } = e, a = ou(Ur, n);
    return /* @__PURE__ */ d(te, { present: o || a.checked, children: /* @__PURE__ */ d(
      _.span,
      {
        "data-state": zr(a.checked),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    ) });
  }
);
Kr.displayName = Ur;
var ru = "RadioBubbleInput", Gr = c.forwardRef(
  ({
    __scopeRadio: e,
    control: t,
    checked: n,
    bubbles: o = !0,
    ...r
  }, a) => {
    const i = c.useRef(null), s = $(i, a), l = mt(n), u = ht(t);
    return c.useEffect(() => {
      const p = i.current;
      if (!p) return;
      const f = window.HTMLInputElement.prototype, v = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && v) {
        const w = new Event("click", { bubbles: o });
        v.call(p, n), p.dispatchEvent(w);
      }
    }, [l, n, o]), /* @__PURE__ */ d(
      _.input,
      {
        type: "radio",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...u,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Gr.displayName = ru;
function zr(e) {
  return e ? "checked" : "unchecked";
}
var au = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], qt = "RadioGroup", [iu] = ee(qt, [
  Qe,
  Wr
]), jr = Qe(), Yr = Wr(), [su, cu] = iu(qt), Xr = c.forwardRef(
  (e, t) => {
    const {
      __scopeRadioGroup: n,
      name: o,
      defaultValue: r,
      value: a,
      required: i = !1,
      disabled: s = !1,
      orientation: l,
      dir: u,
      loop: p = !0,
      onValueChange: f,
      ...m
    } = e, v = jr(n), w = ke(u), [h, g] = ae({
      prop: a,
      defaultProp: r ?? null,
      onChange: f,
      caller: qt
    });
    return /* @__PURE__ */ d(
      su,
      {
        scope: n,
        name: o,
        required: i,
        disabled: s,
        value: h,
        onValueChange: g,
        children: /* @__PURE__ */ d(
          Qn,
          {
            asChild: !0,
            ...v,
            orientation: l,
            dir: w,
            loop: p,
            children: /* @__PURE__ */ d(
              _.div,
              {
                role: "radiogroup",
                "aria-required": i,
                "aria-orientation": l,
                "data-disabled": s ? "" : void 0,
                dir: w,
                ...m,
                ref: t
              }
            )
          }
        )
      }
    );
  }
);
Xr.displayName = qt;
var qr = "RadioGroupItem", Zr = c.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, disabled: o, ...r } = e, a = cu(qr, n), i = a.disabled || o, s = jr(n), l = Yr(n), u = c.useRef(null), p = $(t, u), f = a.value === r.value, m = c.useRef(!1);
    return c.useEffect(() => {
      const v = (h) => {
        au.includes(h.key) && (m.current = !0);
      }, w = () => m.current = !1;
      return document.addEventListener("keydown", v), document.addEventListener("keyup", w), () => {
        document.removeEventListener("keydown", v), document.removeEventListener("keyup", w);
      };
    }, []), /* @__PURE__ */ d(
      Jn,
      {
        asChild: !0,
        ...s,
        focusable: !i,
        active: f,
        children: /* @__PURE__ */ d(
          Hr,
          {
            disabled: i,
            required: a.required,
            checked: f,
            ...l,
            ...r,
            name: a.name,
            ref: p,
            onCheck: () => a.onValueChange(r.value),
            onKeyDown: E((v) => {
              v.key === "Enter" && v.preventDefault();
            }),
            onFocus: E(r.onFocus, () => {
              var v;
              m.current && ((v = u.current) == null || v.click());
            })
          }
        )
      }
    );
  }
);
Zr.displayName = qr;
var lu = "RadioGroupIndicator", Qr = c.forwardRef(
  (e, t) => {
    const { __scopeRadioGroup: n, ...o } = e, r = Yr(n);
    return /* @__PURE__ */ d(Kr, { ...r, ...o, ref: t });
  }
);
Qr.displayName = lu;
var Jr = Xr, ea = Zr, uu = Qr;
const du = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Jr,
  {
    className: D("grid gap-2", e),
    ...t,
    ref: n
  }
));
du.displayName = Jr.displayName;
const fu = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  ea,
  {
    ref: n,
    className: D(
      "aspect-square h-4 w-4 rounded-full border border-primary text-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...t,
    children: /* @__PURE__ */ d(uu, { className: "flex items-center justify-center", children: /* @__PURE__ */ d("div", { className: "h-2.5 w-2.5 rounded-full bg-current" }) })
  }
));
fu.displayName = ea.displayName;
var pu = Symbol.for("react.lazy"), kt = c[" use ".trim().toString()];
function mu(e) {
  return typeof e == "object" && e !== null && "then" in e;
}
function ta(e) {
  return e != null && typeof e == "object" && "$$typeof" in e && e.$$typeof === pu && "_payload" in e && mu(e._payload);
}
// @__NO_SIDE_EFFECTS__
function hu(e) {
  const t = /* @__PURE__ */ vu(e), n = c.forwardRef((o, r) => {
    let { children: a, ...i } = o;
    ta(a) && typeof kt == "function" && (a = kt(a._payload));
    const s = c.Children.toArray(a), l = s.find(wu);
    if (l) {
      const u = l.props.children, p = s.map((f) => f === l ? c.Children.count(u) > 1 ? c.Children.only(null) : c.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ d(t, { ...i, ref: r, children: c.isValidElement(u) ? c.cloneElement(u, void 0, p) : null });
    }
    return /* @__PURE__ */ d(t, { ...i, ref: r, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function vu(e) {
  const t = c.forwardRef((n, o) => {
    let { children: r, ...a } = n;
    if (ta(r) && typeof kt == "function" && (r = kt(r._payload)), c.isValidElement(r)) {
      const i = yu(r), s = bu(a, r.props);
      return r.type !== c.Fragment && (s.ref = o ? pt(o, i) : i), c.cloneElement(r, s);
    }
    return c.Children.count(r) > 1 ? c.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var gu = Symbol("radix.slottable");
function wu(e) {
  return c.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === gu;
}
function bu(e, t) {
  const n = { ...t };
  for (const o in t) {
    const r = e[o], a = t[o];
    /^on[A-Z]/.test(o) ? r && a ? n[o] = (...s) => {
      const l = a(...s);
      return r(...s), l;
    } : r && (n[o] = r) : o === "style" ? n[o] = { ...r, ...a } : o === "className" && (n[o] = [r, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function yu(e) {
  var o, r;
  let t = (o = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (r = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Su = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Zt = Su.reduce((e, t) => {
  const n = /* @__PURE__ */ hu(`Primitive.${t}`), o = c.forwardRef((r, a) => {
    const { asChild: i, ...s } = r, l = i ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...s, ref: a });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {}), xu = "Separator", Ho = "horizontal", Cu = ["horizontal", "vertical"], na = c.forwardRef((e, t) => {
  const { decorative: n, orientation: o = Ho, ...r } = e, a = Ru(o) ? o : Ho, s = n ? { role: "none" } : { "aria-orientation": a === "vertical" ? a : void 0, role: "separator" };
  return /* @__PURE__ */ d(
    Zt.div,
    {
      "data-orientation": a,
      ...s,
      ...r,
      ref: t
    }
  );
});
na.displayName = xu;
function Ru(e) {
  return Cu.includes(e);
}
var oa = na;
const Eu = c.forwardRef(
  ({ className: e, orientation: t = "horizontal", decorative: n = !0, ...o }, r) => /* @__PURE__ */ d(
    oa,
    {
      ref: r,
      decorative: n,
      orientation: t,
      className: D(
        "shrink-0 bg-border",
        t === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
        e
      ),
      ...o
    }
  )
);
Eu.displayName = oa.displayName;
var Qt = "Collapsible", [Pu, ra] = ee(Qt), [Nu, to] = Pu(Qt), aa = c.forwardRef(
  (e, t) => {
    const {
      __scopeCollapsible: n,
      open: o,
      defaultOpen: r,
      disabled: a,
      onOpenChange: i,
      ...s
    } = e, [l, u] = ae({
      prop: o,
      defaultProp: r ?? !1,
      onChange: i,
      caller: Qt
    });
    return /* @__PURE__ */ d(
      Nu,
      {
        scope: n,
        disabled: a,
        contentId: re(),
        open: l,
        onOpenToggle: c.useCallback(() => u((p) => !p), [u]),
        children: /* @__PURE__ */ d(
          _.div,
          {
            "data-state": oo(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: t
          }
        )
      }
    );
  }
);
aa.displayName = Qt;
var ia = "CollapsibleTrigger", sa = c.forwardRef(
  (e, t) => {
    const { __scopeCollapsible: n, ...o } = e, r = to(ia, n);
    return /* @__PURE__ */ d(
      _.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": oo(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...o,
        ref: t,
        onClick: E(e.onClick, r.onOpenToggle)
      }
    );
  }
);
sa.displayName = ia;
var no = "CollapsibleContent", ca = c.forwardRef(
  (e, t) => {
    const { forceMount: n, ...o } = e, r = to(no, e.__scopeCollapsible);
    return /* @__PURE__ */ d(te, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ d(Au, { ...o, ref: t, present: a }) });
  }
);
ca.displayName = no;
var Au = c.forwardRef((e, t) => {
  const { __scopeCollapsible: n, present: o, children: r, ...a } = e, i = to(no, n), [s, l] = c.useState(o), u = c.useRef(null), p = $(t, u), f = c.useRef(0), m = f.current, v = c.useRef(0), w = v.current, h = i.open || s, g = c.useRef(h), b = c.useRef(void 0);
  return c.useEffect(() => {
    const y = requestAnimationFrame(() => g.current = !1);
    return () => cancelAnimationFrame(y);
  }, []), J(() => {
    const y = u.current;
    if (y) {
      b.current = b.current || {
        transitionDuration: y.style.transitionDuration,
        animationName: y.style.animationName
      }, y.style.transitionDuration = "0s", y.style.animationName = "none";
      const S = y.getBoundingClientRect();
      f.current = S.height, v.current = S.width, g.current || (y.style.transitionDuration = b.current.transitionDuration, y.style.animationName = b.current.animationName), l(o);
    }
  }, [i.open, o]), /* @__PURE__ */ d(
    _.div,
    {
      "data-state": oo(i.open),
      "data-disabled": i.disabled ? "" : void 0,
      id: i.contentId,
      hidden: !h,
      ...a,
      ref: p,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": w ? `${w}px` : void 0,
        ...e.style
      },
      children: h && r
    }
  );
});
function oo(e) {
  return e ? "open" : "closed";
}
var _u = aa, Mu = sa, Tu = ca, ge = "Accordion", Iu = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [ro, Du, Ou] = vt(ge), [Jt] = ee(ge, [
  Ou,
  ra
]), ao = ra(), la = Z.forwardRef(
  (e, t) => {
    const { type: n, ...o } = e, r = o, a = o;
    return /* @__PURE__ */ d(ro.Provider, { scope: e.__scopeAccordion, children: n === "multiple" ? /* @__PURE__ */ d(Fu, { ...a, ref: t }) : /* @__PURE__ */ d($u, { ...r, ref: t }) });
  }
);
la.displayName = ge;
var [ua, ku] = Jt(ge), [da, Lu] = Jt(
  ge,
  { collapsible: !1 }
), $u = Z.forwardRef(
  (e, t) => {
    const {
      value: n,
      defaultValue: o,
      onValueChange: r = () => {
      },
      collapsible: a = !1,
      ...i
    } = e, [s, l] = ae({
      prop: n,
      defaultProp: o ?? "",
      onChange: r,
      caller: ge
    });
    return /* @__PURE__ */ d(
      ua,
      {
        scope: e.__scopeAccordion,
        value: Z.useMemo(() => s ? [s] : [], [s]),
        onItemOpen: l,
        onItemClose: Z.useCallback(() => a && l(""), [a, l]),
        children: /* @__PURE__ */ d(da, { scope: e.__scopeAccordion, collapsible: a, children: /* @__PURE__ */ d(fa, { ...i, ref: t }) })
      }
    );
  }
), Fu = Z.forwardRef((e, t) => {
  const {
    value: n,
    defaultValue: o,
    onValueChange: r = () => {
    },
    ...a
  } = e, [i, s] = ae({
    prop: n,
    defaultProp: o ?? [],
    onChange: r,
    caller: ge
  }), l = Z.useCallback(
    (p) => s((f = []) => [...f, p]),
    [s]
  ), u = Z.useCallback(
    (p) => s((f = []) => f.filter((m) => m !== p)),
    [s]
  );
  return /* @__PURE__ */ d(
    ua,
    {
      scope: e.__scopeAccordion,
      value: i,
      onItemOpen: l,
      onItemClose: u,
      children: /* @__PURE__ */ d(da, { scope: e.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ d(fa, { ...a, ref: t }) })
    }
  );
}), [Bu, en] = Jt(ge), fa = Z.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, disabled: o, dir: r, orientation: a = "vertical", ...i } = e, s = Z.useRef(null), l = $(s, t), u = Du(n), f = ke(r) === "ltr", m = E(e.onKeyDown, (v) => {
      var A;
      if (!Iu.includes(v.key)) return;
      const w = v.target, h = u().filter((M) => {
        var T;
        return !((T = M.ref.current) != null && T.disabled);
      }), g = h.findIndex((M) => M.ref.current === w), b = h.length;
      if (g === -1) return;
      v.preventDefault();
      let y = g;
      const S = 0, x = b - 1, C = () => {
        y = g + 1, y > x && (y = S);
      }, P = () => {
        y = g - 1, y < S && (y = x);
      };
      switch (v.key) {
        case "Home":
          y = S;
          break;
        case "End":
          y = x;
          break;
        case "ArrowRight":
          a === "horizontal" && (f ? C() : P());
          break;
        case "ArrowDown":
          a === "vertical" && C();
          break;
        case "ArrowLeft":
          a === "horizontal" && (f ? P() : C());
          break;
        case "ArrowUp":
          a === "vertical" && P();
          break;
      }
      const R = y % b;
      (A = h[R].ref.current) == null || A.focus();
    });
    return /* @__PURE__ */ d(
      Bu,
      {
        scope: n,
        disabled: o,
        direction: r,
        orientation: a,
        children: /* @__PURE__ */ d(ro.Slot, { scope: n, children: /* @__PURE__ */ d(
          _.div,
          {
            ...i,
            "data-orientation": a,
            ref: l,
            onKeyDown: o ? void 0 : m
          }
        ) })
      }
    );
  }
), Lt = "AccordionItem", [Vu, io] = Jt(Lt), pa = Z.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, value: o, ...r } = e, a = en(Lt, n), i = ku(Lt, n), s = ao(n), l = re(), u = o && i.value.includes(o) || !1, p = a.disabled || e.disabled;
    return /* @__PURE__ */ d(
      Vu,
      {
        scope: n,
        open: u,
        disabled: p,
        triggerId: l,
        children: /* @__PURE__ */ d(
          _u,
          {
            "data-orientation": a.orientation,
            "data-state": ba(u),
            ...s,
            ...r,
            ref: t,
            disabled: p,
            open: u,
            onOpenChange: (f) => {
              f ? i.onItemOpen(o) : i.onItemClose(o);
            }
          }
        )
      }
    );
  }
);
pa.displayName = Lt;
var ma = "AccordionHeader", ha = Z.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = en(ge, n), a = io(ma, n);
    return /* @__PURE__ */ d(
      _.h3,
      {
        "data-orientation": r.orientation,
        "data-state": ba(a.open),
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
ha.displayName = ma;
var Dn = "AccordionTrigger", va = Z.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = en(ge, n), a = io(Dn, n), i = Lu(Dn, n), s = ao(n);
    return /* @__PURE__ */ d(ro.ItemSlot, { scope: n, children: /* @__PURE__ */ d(
      Mu,
      {
        "aria-disabled": a.open && !i.collapsible || void 0,
        "data-orientation": r.orientation,
        id: a.triggerId,
        ...s,
        ...o,
        ref: t
      }
    ) });
  }
);
va.displayName = Dn;
var ga = "AccordionContent", wa = Z.forwardRef(
  (e, t) => {
    const { __scopeAccordion: n, ...o } = e, r = en(ge, n), a = io(ga, n), i = ao(n);
    return /* @__PURE__ */ d(
      Tu,
      {
        role: "region",
        "aria-labelledby": a.triggerId,
        "data-orientation": r.orientation,
        ...i,
        ...o,
        ref: t,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...e.style
        }
      }
    );
  }
);
wa.displayName = ga;
function ba(e) {
  return e ? "open" : "closed";
}
var Wu = la, Hu = pa, Uu = ha, ya = va, Sa = wa;
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Ku = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Gu = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase().trim(), pe = (e, t) => {
  const n = jc(
    ({ color: o = "currentColor", size: r = 24, strokeWidth: a = 2, absoluteStrokeWidth: i, className: s = "", children: l, ...u }, p) => $o(
      "svg",
      {
        ref: p,
        ...Ku,
        width: r,
        height: r,
        stroke: o,
        strokeWidth: i ? Number(a) * 24 / Number(r) : a,
        className: ["lucide", `lucide-${Gu(e)}`, s].join(" "),
        ...u
      },
      [
        ...t.map(([f, m]) => $o(f, m)),
        ...Array.isArray(l) ? l : [l]
      ]
    )
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tn = pe("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xa = pe("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zu = pe("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ju = pe("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Yu = pe("Copy", [
  ["rect", { width: "14", height: "14", x: "8", y: "8", rx: "2", ry: "2", key: "17jyea" }],
  ["path", { d: "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2", key: "zix9uf" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Xu = pe("Dices", [
  ["rect", { width: "12", height: "12", x: "2", y: "10", rx: "2", ry: "2", key: "6agr2n" }],
  [
    "path",
    { d: "m17.92 14 3.5-3.5a2.24 2.24 0 0 0 0-3l-5-4.92a2.24 2.24 0 0 0-3 0L10 6", key: "1o487t" }
  ],
  ["path", { d: "M6 18h.01", key: "uhywen" }],
  ["path", { d: "M10 14h.01", key: "ssrbsk" }],
  ["path", { d: "M15 6h.01", key: "cblpky" }],
  ["path", { d: "M18 9h.01", key: "2061c0" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qu = pe("FileX", [
  [
    "path",
    { d: "M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z", key: "1nnpy2" }
  ],
  ["polyline", { points: "14 2 14 8 20 8", key: "1ew0cm" }],
  ["line", { x1: "9.5", x2: "14.5", y1: "12.5", y2: "17.5", key: "izs6du" }],
  ["line", { x1: "14.5", x2: "9.5", y1: "12.5", y2: "17.5", key: "1lehlj" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zu = pe("Loader2", [
  ["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ca = pe("Sparkles", [
  [
    "path",
    {
      d: "m12 3-1.912 5.813a2 2 0 0 1-1.275 1.275L3 12l5.813 1.912a2 2 0 0 1 1.275 1.275L12 21l1.912-5.813a2 2 0 0 1 1.275-1.275L21 12l-5.813-1.912a2 2 0 0 1-1.275-1.275L12 3Z",
      key: "17u4zn"
    }
  ],
  ["path", { d: "M5 3v4", key: "bklmnn" }],
  ["path", { d: "M19 17v4", key: "iiml17" }],
  ["path", { d: "M3 5h4", key: "nem4j1" }],
  ["path", { d: "M17 19h4", key: "lbex7p" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Qu = pe("StarOff", [
  ["path", { d: "M8.34 8.34 2 9.27l5 4.87L5.82 21 12 17.77 18.18 21l-.59-3.43", key: "16m0ql" }],
  ["path", { d: "M18.42 12.76 22 9.27l-6.91-1L12 2l-1.44 2.91", key: "1vt8nq" }],
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ju = pe("Star", [
  [
    "polygon",
    {
      points: "12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2",
      key: "8f66p6"
    }
  ]
]);
/**
 * @license lucide-react v0.303.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ed = pe("X", [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
]), Lv = Wu, td = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Hu,
  {
    ref: n,
    className: D("border-b", e),
    ...t
  }
));
td.displayName = "AccordionItem";
const nd = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ d(Uu, { className: "flex", children: /* @__PURE__ */ H(
  ya,
  {
    ref: o,
    className: D(
      "flex flex-1 items-center justify-between py-4 font-medium transition-all hover:underline [&[data-state=open]>svg]:rotate-180",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ d(xa, { className: "h-4 w-4 shrink-0 transition-transform duration-200" })
    ]
  }
) }));
nd.displayName = ya.displayName;
const od = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ d(
  Sa,
  {
    ref: o,
    className: D(
      "overflow-hidden text-sm transition-all data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
      e
    ),
    ...n,
    children: /* @__PURE__ */ d("div", { className: "pb-4 pt-0", children: t })
  }
));
od.displayName = Sa.displayName;
function rd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Q(e);
  c.useEffect(() => {
    const o = (r) => {
      r.key === "Escape" && n(r);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [n, t]);
}
var ad = "DismissableLayer", On = "dismissableLayer.update", id = "dismissableLayer.pointerDownOutside", sd = "dismissableLayer.focusOutside", Uo, Ra = c.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nn = c.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, u = c.useContext(Ra), [p, f] = c.useState(null), m = (p == null ? void 0 : p.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, v] = c.useState({}), w = $(t, (R) => f(R)), h = Array.from(u.layers), [g] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = h.indexOf(g), y = p ? h.indexOf(p) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= b, C = ud((R) => {
      const A = R.target, M = [...u.branches].some((T) => T.contains(A));
      !x || M || (r == null || r(R), i == null || i(R), R.defaultPrevented || s == null || s());
    }, m), P = dd((R) => {
      const A = R.target;
      [...u.branches].some((T) => T.contains(A)) || (a == null || a(R), i == null || i(R), R.defaultPrevented || s == null || s());
    }, m);
    return rd((R) => {
      y === u.layers.size - 1 && (o == null || o(R), !R.defaultPrevented && s && (R.preventDefault(), s()));
    }, m), c.useEffect(() => {
      if (p)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (Uo = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(p)), u.layers.add(p), Ko(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = Uo);
        };
    }, [p, m, n, u]), c.useEffect(() => () => {
      p && (u.layers.delete(p), u.layersWithOutsidePointerEventsDisabled.delete(p), Ko());
    }, [p, u]), c.useEffect(() => {
      const R = () => v({});
      return document.addEventListener(On, R), () => document.removeEventListener(On, R);
    }, []), /* @__PURE__ */ d(
      _.div,
      {
        ...l,
        ref: w,
        style: {
          pointerEvents: S ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: E(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: E(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: E(
          e.onPointerDownCapture,
          C.onPointerDownCapture
        )
      }
    );
  }
);
nn.displayName = ad;
var cd = "DismissableLayerBranch", ld = c.forwardRef((e, t) => {
  const n = c.useContext(Ra), o = c.useRef(null), r = $(t, o);
  return c.useEffect(() => {
    const a = o.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ d(_.div, { ...e, ref: r });
});
ld.displayName = cd;
function ud(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Q(e), o = c.useRef(!1), r = c.useRef(() => {
  });
  return c.useEffect(() => {
    const a = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          Ea(
            id,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", r.current), r.current = l, t.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", r.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", a), t.removeEventListener("click", r.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function dd(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Q(e), o = c.useRef(!1);
  return c.useEffect(() => {
    const r = (a) => {
      a.target && !o.current && Ea(sd, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", r), () => t.removeEventListener("focusin", r);
  }, [t, n]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Ko() {
  const e = new CustomEvent(On);
  document.dispatchEvent(e);
}
function Ea(e, t, n, { discrete: o }) {
  const r = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && r.addEventListener(e, t, { once: !0 }), o ? hr(r, a) : r.dispatchEvent(a);
}
var Cn = 0;
function so() {
  c.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Go()), document.body.insertAdjacentElement("beforeend", e[1] ?? Go()), Cn++, () => {
      Cn === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Cn--;
    };
  }, []);
}
function Go() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Rn = "focusScope.autoFocusOnMount", En = "focusScope.autoFocusOnUnmount", zo = { bubbles: !1, cancelable: !0 }, fd = "FocusScope", on = c.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: o = !1,
    onMountAutoFocus: r,
    onUnmountAutoFocus: a,
    ...i
  } = e, [s, l] = c.useState(null), u = Q(r), p = Q(a), f = c.useRef(null), m = $(t, (h) => l(h)), v = c.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  c.useEffect(() => {
    if (o) {
      let h = function(S) {
        if (v.paused || !s) return;
        const x = S.target;
        s.contains(x) ? f.current = x : Te(f.current, { select: !0 });
      }, g = function(S) {
        if (v.paused || !s) return;
        const x = S.relatedTarget;
        x !== null && (s.contains(x) || Te(f.current, { select: !0 }));
      }, b = function(S) {
        if (document.activeElement === document.body)
          for (const C of S)
            C.removedNodes.length > 0 && Te(s);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", g);
      const y = new MutationObserver(b);
      return s && y.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", g), y.disconnect();
      };
    }
  }, [o, s, v.paused]), c.useEffect(() => {
    if (s) {
      Yo.add(v);
      const h = document.activeElement;
      if (!s.contains(h)) {
        const b = new CustomEvent(Rn, zo);
        s.addEventListener(Rn, u), s.dispatchEvent(b), b.defaultPrevented || (pd(wd(Pa(s)), { select: !0 }), document.activeElement === h && Te(s));
      }
      return () => {
        s.removeEventListener(Rn, u), setTimeout(() => {
          const b = new CustomEvent(En, zo);
          s.addEventListener(En, p), s.dispatchEvent(b), b.defaultPrevented || Te(h ?? document.body, { select: !0 }), s.removeEventListener(En, p), Yo.remove(v);
        }, 0);
      };
    }
  }, [s, u, p, v]);
  const w = c.useCallback(
    (h) => {
      if (!n && !o || v.paused) return;
      const g = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, b = document.activeElement;
      if (g && b) {
        const y = h.currentTarget, [S, x] = md(y);
        S && x ? !h.shiftKey && b === x ? (h.preventDefault(), n && Te(S, { select: !0 })) : h.shiftKey && b === S && (h.preventDefault(), n && Te(x, { select: !0 })) : b === y && h.preventDefault();
      }
    },
    [n, o, v.paused]
  );
  return /* @__PURE__ */ d(_.div, { tabIndex: -1, ...i, ref: m, onKeyDown: w });
});
on.displayName = fd;
function pd(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const o of e)
    if (Te(o, { select: t }), document.activeElement !== n) return;
}
function md(e) {
  const t = Pa(e), n = jo(t, e), o = jo(t.reverse(), e);
  return [n, o];
}
function Pa(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const r = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || r ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function jo(e, t) {
  for (const n of e)
    if (!hd(n, { upTo: t })) return n;
}
function hd(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function vd(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Te(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && vd(e) && t && e.select();
  }
}
var Yo = gd();
function gd() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Xo(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Xo(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Xo(e, t) {
  const n = [...e], o = n.indexOf(t);
  return o !== -1 && n.splice(o, 1), n;
}
function wd(e) {
  return e.filter((t) => t.tagName !== "A");
}
const bd = ["top", "right", "bottom", "left"], De = Math.min, ce = Math.max, $t = Math.round, Et = Math.floor, xe = (e) => ({
  x: e,
  y: e
}), yd = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Sd = {
  start: "end",
  end: "start"
};
function kn(e, t, n) {
  return ce(e, De(t, n));
}
function _e(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Me(e) {
  return e.split("-")[0];
}
function Je(e) {
  return e.split("-")[1];
}
function co(e) {
  return e === "x" ? "y" : "x";
}
function lo(e) {
  return e === "y" ? "height" : "width";
}
const xd = /* @__PURE__ */ new Set(["top", "bottom"]);
function Se(e) {
  return xd.has(Me(e)) ? "y" : "x";
}
function uo(e) {
  return co(Se(e));
}
function Cd(e, t, n) {
  n === void 0 && (n = !1);
  const o = Je(e), r = uo(e), a = lo(r);
  let i = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Ft(i)), [i, Ft(i)];
}
function Rd(e) {
  const t = Ft(e);
  return [Ln(e), t, Ln(t)];
}
function Ln(e) {
  return e.replace(/start|end/g, (t) => Sd[t]);
}
const qo = ["left", "right"], Zo = ["right", "left"], Ed = ["top", "bottom"], Pd = ["bottom", "top"];
function Nd(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? Zo : qo : t ? qo : Zo;
    case "left":
    case "right":
      return t ? Ed : Pd;
    default:
      return [];
  }
}
function Ad(e, t, n, o) {
  const r = Je(e);
  let a = Nd(Me(e), n === "start", o);
  return r && (a = a.map((i) => i + "-" + r), t && (a = a.concat(a.map(Ln)))), a;
}
function Ft(e) {
  return e.replace(/left|right|bottom|top/g, (t) => yd[t]);
}
function _d(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Na(e) {
  return typeof e != "number" ? _d(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Bt(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: r
  } = e;
  return {
    width: o,
    height: r,
    top: n,
    left: t,
    right: t + o,
    bottom: n + r,
    x: t,
    y: n
  };
}
function Qo(e, t, n) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = Se(t), i = uo(t), s = lo(i), l = Me(t), u = a === "y", p = o.x + o.width / 2 - r.width / 2, f = o.y + o.height / 2 - r.height / 2, m = o[s] / 2 - r[s] / 2;
  let v;
  switch (l) {
    case "top":
      v = {
        x: p,
        y: o.y - r.height
      };
      break;
    case "bottom":
      v = {
        x: p,
        y: o.y + o.height
      };
      break;
    case "right":
      v = {
        x: o.x + o.width,
        y: f
      };
      break;
    case "left":
      v = {
        x: o.x - r.width,
        y: f
      };
      break;
    default:
      v = {
        x: o.x,
        y: o.y
      };
  }
  switch (Je(t)) {
    case "start":
      v[i] -= m * (n && u ? -1 : 1);
      break;
    case "end":
      v[i] += m * (n && u ? -1 : 1);
      break;
  }
  return v;
}
const Md = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: i
  } = n, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: p,
    y: f
  } = Qo(u, o, l), m = o, v = {}, w = 0;
  for (let h = 0; h < s.length; h++) {
    const {
      name: g,
      fn: b
    } = s[h], {
      x: y,
      y: S,
      data: x,
      reset: C
    } = await b({
      x: p,
      y: f,
      initialPlacement: o,
      placement: m,
      strategy: r,
      middlewareData: v,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    p = y ?? p, f = S ?? f, v = {
      ...v,
      [g]: {
        ...v[g],
        ...x
      }
    }, C && w <= 50 && (w++, typeof C == "object" && (C.placement && (m = C.placement), C.rects && (u = C.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : C.rects), {
      x: p,
      y: f
    } = Qo(u, m, l)), h = -1);
  }
  return {
    x: p,
    y: f,
    placement: m,
    strategy: r,
    middlewareData: v
  };
};
async function lt(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: p = "viewport",
    elementContext: f = "floating",
    altBoundary: m = !1,
    padding: v = 0
  } = _e(t, e), w = Na(v), g = s[m ? f === "floating" ? "reference" : "floating" : f], b = Bt(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: p,
    strategy: l
  })), y = f === "floating" ? {
    x: o,
    y: r,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, S = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), x = await (a.isElement == null ? void 0 : a.isElement(S)) ? await (a.getScale == null ? void 0 : a.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, C = Bt(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: y,
    offsetParent: S,
    strategy: l
  }) : y);
  return {
    top: (b.top - C.top + w.top) / x.y,
    bottom: (C.bottom - b.bottom + w.bottom) / x.y,
    left: (b.left - C.left + w.left) / x.x,
    right: (C.right - b.right + w.right) / x.x
  };
}
const Td = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: a,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: p = 0
    } = _e(e, t) || {};
    if (u == null)
      return {};
    const f = Na(p), m = {
      x: n,
      y: o
    }, v = uo(r), w = lo(v), h = await i.getDimensions(u), g = v === "y", b = g ? "top" : "left", y = g ? "bottom" : "right", S = g ? "clientHeight" : "clientWidth", x = a.reference[w] + a.reference[v] - m[v] - a.floating[w], C = m[v] - a.reference[v], P = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(u));
    let R = P ? P[S] : 0;
    (!R || !await (i.isElement == null ? void 0 : i.isElement(P))) && (R = s.floating[S] || a.floating[w]);
    const A = x / 2 - C / 2, M = R / 2 - h[w] / 2 - 1, T = De(f[b], M), O = De(f[y], M), F = T, B = R - h[w] - O, V = R / 2 - h[w] / 2 + A, U = kn(F, V, B), L = !l.arrow && Je(r) != null && V !== U && a.reference[w] / 2 - (V < F ? T : O) - h[w] / 2 < 0, W = L ? V < F ? V - F : V - B : 0;
    return {
      [v]: m[v] + W,
      data: {
        [v]: U,
        centerOffset: V - U - W,
        ...L && {
          alignmentOffset: W
        }
      },
      reset: L
    };
  }
}), Id = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: p = !0,
        crossAxis: f = !0,
        fallbackPlacements: m,
        fallbackStrategy: v = "bestFit",
        fallbackAxisSideDirection: w = "none",
        flipAlignment: h = !0,
        ...g
      } = _e(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const b = Me(r), y = Se(s), S = Me(s) === s, x = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), C = m || (S || !h ? [Ft(s)] : Rd(s)), P = w !== "none";
      !m && P && C.push(...Ad(s, h, w, x));
      const R = [s, ...C], A = await lt(t, g), M = [];
      let T = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (p && M.push(A[b]), f) {
        const V = Cd(r, i, x);
        M.push(A[V[0]], A[V[1]]);
      }
      if (T = [...T, {
        placement: r,
        overflows: M
      }], !M.every((V) => V <= 0)) {
        var O, F;
        const V = (((O = a.flip) == null ? void 0 : O.index) || 0) + 1, U = R[V];
        if (U && (!(f === "alignment" ? y !== Se(U) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        T.every((I) => Se(I.placement) === y ? I.overflows[0] > 0 : !0)))
          return {
            data: {
              index: V,
              overflows: T
            },
            reset: {
              placement: U
            }
          };
        let L = (F = T.filter((W) => W.overflows[0] <= 0).sort((W, I) => W.overflows[1] - I.overflows[1])[0]) == null ? void 0 : F.placement;
        if (!L)
          switch (v) {
            case "bestFit": {
              var B;
              const W = (B = T.filter((I) => {
                if (P) {
                  const N = Se(I.placement);
                  return N === y || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  N === "y";
                }
                return !0;
              }).map((I) => [I.placement, I.overflows.filter((N) => N > 0).reduce((N, Y) => N + Y, 0)]).sort((I, N) => I[1] - N[1])[0]) == null ? void 0 : B[0];
              W && (L = W);
              break;
            }
            case "initialPlacement":
              L = s;
              break;
          }
        if (r !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function Jo(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function er(e) {
  return bd.some((t) => e[t] >= 0);
}
const Dd = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = _e(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await lt(t, {
            ...r,
            elementContext: "reference"
          }), i = Jo(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: er(i)
            }
          };
        }
        case "escaped": {
          const a = await lt(t, {
            ...r,
            altBoundary: !0
          }), i = Jo(a, n.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: er(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Aa = /* @__PURE__ */ new Set(["left", "top"]);
async function Od(e, t) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), i = Me(n), s = Je(n), l = Se(n) === "y", u = Aa.has(i) ? -1 : 1, p = a && l ? -1 : 1, f = _e(t, e);
  let {
    mainAxis: m,
    crossAxis: v,
    alignmentAxis: w
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof w == "number" && (v = s === "end" ? w * -1 : w), l ? {
    x: v * p,
    y: m * u
  } : {
    x: m * u,
    y: v * p
  };
}
const kd = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: r,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await Od(t, e);
      return i === ((n = s.offset) == null ? void 0 : n.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, Ld = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (g) => {
            let {
              x: b,
              y
            } = g;
            return {
              x: b,
              y
            };
          }
        },
        ...l
      } = _e(e, t), u = {
        x: n,
        y: o
      }, p = await lt(t, l), f = Se(Me(r)), m = co(f);
      let v = u[m], w = u[f];
      if (a) {
        const g = m === "y" ? "top" : "left", b = m === "y" ? "bottom" : "right", y = v + p[g], S = v - p[b];
        v = kn(y, v, S);
      }
      if (i) {
        const g = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", y = w + p[g], S = w - p[b];
        w = kn(y, w, S);
      }
      const h = s.fn({
        ...t,
        [m]: v,
        [f]: w
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - o,
          enabled: {
            [m]: a,
            [f]: i
          }
        }
      };
    }
  };
}, $d = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: r,
        rects: a,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = _e(e, t), p = {
        x: n,
        y: o
      }, f = Se(r), m = co(f);
      let v = p[m], w = p[f];
      const h = _e(s, t), g = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (l) {
        const S = m === "y" ? "height" : "width", x = a.reference[m] - a.floating[S] + g.mainAxis, C = a.reference[m] + a.reference[S] - g.mainAxis;
        v < x ? v = x : v > C && (v = C);
      }
      if (u) {
        var b, y;
        const S = m === "y" ? "width" : "height", x = Aa.has(Me(r)), C = a.reference[f] - a.floating[S] + (x && ((b = i.offset) == null ? void 0 : b[f]) || 0) + (x ? 0 : g.crossAxis), P = a.reference[f] + a.reference[S] + (x ? 0 : ((y = i.offset) == null ? void 0 : y[f]) || 0) - (x ? g.crossAxis : 0);
        w < C ? w = C : w > P && (w = P);
      }
      return {
        [m]: v,
        [f]: w
      };
    }
  };
}, Fd = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: r,
        rects: a,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = _e(e, t), p = await lt(t, u), f = Me(r), m = Je(r), v = Se(r) === "y", {
        width: w,
        height: h
      } = a.floating;
      let g, b;
      f === "top" || f === "bottom" ? (g = f, b = m === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = f, g = m === "end" ? "top" : "bottom");
      const y = h - p.top - p.bottom, S = w - p.left - p.right, x = De(h - p[g], y), C = De(w - p[b], S), P = !t.middlewareData.shift;
      let R = x, A = C;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (A = S), (o = t.middlewareData.shift) != null && o.enabled.y && (R = y), P && !m) {
        const T = ce(p.left, 0), O = ce(p.right, 0), F = ce(p.top, 0), B = ce(p.bottom, 0);
        v ? A = w - 2 * (T !== 0 || O !== 0 ? T + O : ce(p.left, p.right)) : R = h - 2 * (F !== 0 || B !== 0 ? F + B : ce(p.top, p.bottom));
      }
      await l({
        ...t,
        availableWidth: A,
        availableHeight: R
      });
      const M = await i.getDimensions(s.floating);
      return w !== M.width || h !== M.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function rn() {
  return typeof window < "u";
}
function et(e) {
  return _a(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function le(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ee(e) {
  var t;
  return (t = (_a(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function _a(e) {
  return rn() ? e instanceof Node || e instanceof le(e).Node : !1;
}
function he(e) {
  return rn() ? e instanceof Element || e instanceof le(e).Element : !1;
}
function Ce(e) {
  return rn() ? e instanceof HTMLElement || e instanceof le(e).HTMLElement : !1;
}
function tr(e) {
  return !rn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof le(e).ShadowRoot;
}
const Bd = /* @__PURE__ */ new Set(["inline", "contents"]);
function wt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: r
  } = ve(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !Bd.has(r);
}
const Vd = /* @__PURE__ */ new Set(["table", "td", "th"]);
function Wd(e) {
  return Vd.has(et(e));
}
const Hd = [":popover-open", ":modal"];
function an(e) {
  return Hd.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const Ud = ["transform", "translate", "scale", "rotate", "perspective"], Kd = ["transform", "translate", "scale", "rotate", "perspective", "filter"], Gd = ["paint", "layout", "strict", "content"];
function fo(e) {
  const t = po(), n = he(e) ? ve(e) : e;
  return Ud.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || Kd.some((o) => (n.willChange || "").includes(o)) || Gd.some((o) => (n.contain || "").includes(o));
}
function zd(e) {
  let t = Oe(e);
  for (; Ce(t) && !Ze(t); ) {
    if (fo(t))
      return t;
    if (an(t))
      return null;
    t = Oe(t);
  }
  return null;
}
function po() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const jd = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Ze(e) {
  return jd.has(et(e));
}
function ve(e) {
  return le(e).getComputedStyle(e);
}
function sn(e) {
  return he(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Oe(e) {
  if (et(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    tr(e) && e.host || // Fallback.
    Ee(e)
  );
  return tr(t) ? t.host : t;
}
function Ma(e) {
  const t = Oe(e);
  return Ze(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ce(t) && wt(t) ? t : Ma(t);
}
function ut(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const r = Ma(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), i = le(r);
  if (a) {
    const s = $n(i);
    return t.concat(i, i.visualViewport || [], wt(r) ? r : [], s && n ? ut(s) : []);
  }
  return t.concat(r, ut(r, [], n));
}
function $n(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Ta(e) {
  const t = ve(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = Ce(e), a = r ? e.offsetWidth : n, i = r ? e.offsetHeight : o, s = $t(n) !== a || $t(o) !== i;
  return s && (n = a, o = i), {
    width: n,
    height: o,
    $: s
  };
}
function mo(e) {
  return he(e) ? e : e.contextElement;
}
function je(e) {
  const t = mo(e);
  if (!Ce(t))
    return xe(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = Ta(t);
  let i = (a ? $t(n.width) : n.width) / o, s = (a ? $t(n.height) : n.height) / r;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const Yd = /* @__PURE__ */ xe(0);
function Ia(e) {
  const t = le(e);
  return !po() || !t.visualViewport ? Yd : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Xd(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== le(e) ? !1 : t;
}
function Be(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), a = mo(e);
  let i = xe(1);
  t && (o ? he(o) && (i = je(o)) : i = je(e));
  const s = Xd(a, n, o) ? Ia(a) : xe(0);
  let l = (r.left + s.x) / i.x, u = (r.top + s.y) / i.y, p = r.width / i.x, f = r.height / i.y;
  if (a) {
    const m = le(a), v = o && he(o) ? le(o) : o;
    let w = m, h = $n(w);
    for (; h && o && v !== w; ) {
      const g = je(h), b = h.getBoundingClientRect(), y = ve(h), S = b.left + (h.clientLeft + parseFloat(y.paddingLeft)) * g.x, x = b.top + (h.clientTop + parseFloat(y.paddingTop)) * g.y;
      l *= g.x, u *= g.y, p *= g.x, f *= g.y, l += S, u += x, w = le(h), h = $n(w);
    }
  }
  return Bt({
    width: p,
    height: f,
    x: l,
    y: u
  });
}
function cn(e, t) {
  const n = sn(e).scrollLeft;
  return t ? t.left + n : Be(Ee(e)).left + n;
}
function Da(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - cn(e, n), r = n.top + t.scrollTop;
  return {
    x: o,
    y: r
  };
}
function qd(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", i = Ee(o), s = t ? an(t.floating) : !1;
  if (o === i || s && a)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = xe(1);
  const p = xe(0), f = Ce(o);
  if ((f || !f && !a) && ((et(o) !== "body" || wt(i)) && (l = sn(o)), Ce(o))) {
    const v = Be(o);
    u = je(o), p.x = v.x + o.clientLeft, p.y = v.y + o.clientTop;
  }
  const m = i && !f && !a ? Da(i, l) : xe(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + p.x + m.x,
    y: n.y * u.y - l.scrollTop * u.y + p.y + m.y
  };
}
function Zd(e) {
  return Array.from(e.getClientRects());
}
function Qd(e) {
  const t = Ee(e), n = sn(e), o = e.ownerDocument.body, r = ce(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = ce(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -n.scrollLeft + cn(e);
  const s = -n.scrollTop;
  return ve(o).direction === "rtl" && (i += ce(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: i,
    y: s
  };
}
const nr = 25;
function Jd(e, t) {
  const n = le(e), o = Ee(e), r = n.visualViewport;
  let a = o.clientWidth, i = o.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, i = r.height;
    const p = po();
    (!p || p && t === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  const u = cn(o);
  if (u <= 0) {
    const p = o.ownerDocument, f = p.body, m = getComputedStyle(f), v = p.compatMode === "CSS1Compat" && parseFloat(m.marginLeft) + parseFloat(m.marginRight) || 0, w = Math.abs(o.clientWidth - f.clientWidth - v);
    w <= nr && (a -= w);
  } else u <= nr && (a += u);
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
const ef = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function tf(e, t) {
  const n = Be(e, !0, t === "fixed"), o = n.top + e.clientTop, r = n.left + e.clientLeft, a = Ce(e) ? je(e) : xe(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = r * a.x, u = o * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function or(e, t, n) {
  let o;
  if (t === "viewport")
    o = Jd(e, n);
  else if (t === "document")
    o = Qd(Ee(e));
  else if (he(t))
    o = tf(t, n);
  else {
    const r = Ia(e);
    o = {
      x: t.x - r.x,
      y: t.y - r.y,
      width: t.width,
      height: t.height
    };
  }
  return Bt(o);
}
function Oa(e, t) {
  const n = Oe(e);
  return n === t || !he(n) || Ze(n) ? !1 : ve(n).position === "fixed" || Oa(n, t);
}
function nf(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = ut(e, [], !1).filter((s) => he(s) && et(s) !== "body"), r = null;
  const a = ve(e).position === "fixed";
  let i = a ? Oe(e) : e;
  for (; he(i) && !Ze(i); ) {
    const s = ve(i), l = fo(i);
    !l && s.position === "fixed" && (r = null), (a ? !l && !r : !l && s.position === "static" && !!r && ef.has(r.position) || wt(i) && !l && Oa(e, i)) ? o = o.filter((p) => p !== i) : r = s, i = Oe(i);
  }
  return t.set(e, o), o;
}
function of(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = e;
  const i = [...n === "clippingAncestors" ? an(t) ? [] : nf(t, this._c) : [].concat(n), o], s = i[0], l = i.reduce((u, p) => {
    const f = or(t, p, r);
    return u.top = ce(f.top, u.top), u.right = De(f.right, u.right), u.bottom = De(f.bottom, u.bottom), u.left = ce(f.left, u.left), u;
  }, or(t, s, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function rf(e) {
  const {
    width: t,
    height: n
  } = Ta(e);
  return {
    width: t,
    height: n
  };
}
function af(e, t, n) {
  const o = Ce(t), r = Ee(t), a = n === "fixed", i = Be(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = xe(0);
  function u() {
    l.x = cn(r);
  }
  if (o || !o && !a)
    if ((et(t) !== "body" || wt(r)) && (s = sn(t)), o) {
      const v = Be(t, !0, a, t);
      l.x = v.x + t.clientLeft, l.y = v.y + t.clientTop;
    } else r && u();
  a && !o && r && u();
  const p = r && !o && !a ? Da(r, s) : xe(0), f = i.left + s.scrollLeft - l.x - p.x, m = i.top + s.scrollTop - l.y - p.y;
  return {
    x: f,
    y: m,
    width: i.width,
    height: i.height
  };
}
function Pn(e) {
  return ve(e).position === "static";
}
function rr(e, t) {
  if (!Ce(e) || ve(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ee(e) === n && (n = n.ownerDocument.body), n;
}
function ka(e, t) {
  const n = le(e);
  if (an(e))
    return n;
  if (!Ce(e)) {
    let r = Oe(e);
    for (; r && !Ze(r); ) {
      if (he(r) && !Pn(r))
        return r;
      r = Oe(r);
    }
    return n;
  }
  let o = rr(e, t);
  for (; o && Wd(o) && Pn(o); )
    o = rr(o, t);
  return o && Ze(o) && Pn(o) && !fo(o) ? n : o || zd(e) || n;
}
const sf = async function(e) {
  const t = this.getOffsetParent || ka, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: af(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function cf(e) {
  return ve(e).direction === "rtl";
}
const lf = {
  convertOffsetParentRelativeRectToViewportRelativeRect: qd,
  getDocumentElement: Ee,
  getClippingRect: of,
  getOffsetParent: ka,
  getElementRects: sf,
  getClientRects: Zd,
  getDimensions: rf,
  getScale: je,
  isElement: he,
  isRTL: cf
};
function La(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function uf(e, t) {
  let n = null, o;
  const r = Ee(e);
  function a() {
    var s;
    clearTimeout(o), (s = n) == null || s.disconnect(), n = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const u = e.getBoundingClientRect(), {
      left: p,
      top: f,
      width: m,
      height: v
    } = u;
    if (s || t(), !m || !v)
      return;
    const w = Et(f), h = Et(r.clientWidth - (p + m)), g = Et(r.clientHeight - (f + v)), b = Et(p), S = {
      rootMargin: -w + "px " + -h + "px " + -g + "px " + -b + "px",
      threshold: ce(0, De(1, l)) || 1
    };
    let x = !0;
    function C(P) {
      const R = P[0].intersectionRatio;
      if (R !== l) {
        if (!x)
          return i();
        R ? i(!1, R) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      R === 1 && !La(u, e.getBoundingClientRect()) && i(), x = !1;
    }
    try {
      n = new IntersectionObserver(C, {
        ...S,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(C, S);
    }
    n.observe(e);
  }
  return i(!0), a;
}
function df(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, u = mo(e), p = r || a ? [...u ? ut(u) : [], ...ut(t)] : [];
  p.forEach((b) => {
    r && b.addEventListener("scroll", n, {
      passive: !0
    }), a && b.addEventListener("resize", n);
  });
  const f = u && s ? uf(u, n) : null;
  let m = -1, v = null;
  i && (v = new ResizeObserver((b) => {
    let [y] = b;
    y && y.target === u && v && (v.unobserve(t), cancelAnimationFrame(m), m = requestAnimationFrame(() => {
      var S;
      (S = v) == null || S.observe(t);
    })), n();
  }), u && !l && v.observe(u), v.observe(t));
  let w, h = l ? Be(e) : null;
  l && g();
  function g() {
    const b = Be(e);
    h && !La(h, b) && n(), h = b, w = requestAnimationFrame(g);
  }
  return n(), () => {
    var b;
    p.forEach((y) => {
      r && y.removeEventListener("scroll", n), a && y.removeEventListener("resize", n);
    }), f == null || f(), (b = v) == null || b.disconnect(), v = null, l && cancelAnimationFrame(w);
  };
}
const ff = kd, pf = Ld, mf = Id, hf = Fd, vf = Dd, ar = Td, gf = $d, wf = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: lf,
    ...n
  }, a = {
    ...r.platform,
    _c: o
  };
  return Md(e, t, {
    ...r,
    platform: a
  });
};
var bf = typeof document < "u", yf = function() {
}, Mt = bf ? Yc : yf;
function Vt(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, o, r;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (o = n; o-- !== 0; )
        if (!Vt(e[o], t[o]))
          return !1;
      return !0;
    }
    if (r = Object.keys(e), n = r.length, n !== Object.keys(t).length)
      return !1;
    for (o = n; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, r[o]))
        return !1;
    for (o = n; o-- !== 0; ) {
      const a = r[o];
      if (!(a === "_owner" && e.$$typeof) && !Vt(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function $a(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ir(e, t) {
  const n = $a(e);
  return Math.round(t * n) / n;
}
function Nn(e) {
  const t = c.useRef(e);
  return Mt(() => {
    t.current = e;
  }), t;
}
function Sf(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: o = [],
    platform: r,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [p, f] = c.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [m, v] = c.useState(o);
  Vt(m, o) || v(o);
  const [w, h] = c.useState(null), [g, b] = c.useState(null), y = c.useCallback((I) => {
    I !== P.current && (P.current = I, h(I));
  }, []), S = c.useCallback((I) => {
    I !== R.current && (R.current = I, b(I));
  }, []), x = a || w, C = i || g, P = c.useRef(null), R = c.useRef(null), A = c.useRef(p), M = l != null, T = Nn(l), O = Nn(r), F = Nn(u), B = c.useCallback(() => {
    if (!P.current || !R.current)
      return;
    const I = {
      placement: t,
      strategy: n,
      middleware: m
    };
    O.current && (I.platform = O.current), wf(P.current, R.current, I).then((N) => {
      const Y = {
        ...N,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: F.current !== !1
      };
      V.current && !Vt(A.current, Y) && (A.current = Y, zt.flushSync(() => {
        f(Y);
      }));
    });
  }, [m, t, n, O, F]);
  Mt(() => {
    u === !1 && A.current.isPositioned && (A.current.isPositioned = !1, f((I) => ({
      ...I,
      isPositioned: !1
    })));
  }, [u]);
  const V = c.useRef(!1);
  Mt(() => (V.current = !0, () => {
    V.current = !1;
  }), []), Mt(() => {
    if (x && (P.current = x), C && (R.current = C), x && C) {
      if (T.current)
        return T.current(x, C, B);
      B();
    }
  }, [x, C, B, T, M]);
  const U = c.useMemo(() => ({
    reference: P,
    floating: R,
    setReference: y,
    setFloating: S
  }), [y, S]), L = c.useMemo(() => ({
    reference: x,
    floating: C
  }), [x, C]), W = c.useMemo(() => {
    const I = {
      position: n,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return I;
    const N = ir(L.floating, p.x), Y = ir(L.floating, p.y);
    return s ? {
      ...I,
      transform: "translate(" + N + "px, " + Y + "px)",
      ...$a(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: N,
      top: Y
    };
  }, [n, s, L.floating, p.x, p.y]);
  return c.useMemo(() => ({
    ...p,
    update: B,
    refs: U,
    elements: L,
    floatingStyles: W
  }), [p, B, U, L, W]);
}
const xf = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: o,
        padding: r
      } = typeof e == "function" ? e(n) : e;
      return o && t(o) ? o.current != null ? ar({
        element: o.current,
        padding: r
      }).fn(n) : {} : o ? ar({
        element: o,
        padding: r
      }).fn(n) : {};
    }
  };
}, Cf = (e, t) => ({
  ...ff(e),
  options: [e, t]
}), Rf = (e, t) => ({
  ...pf(e),
  options: [e, t]
}), Ef = (e, t) => ({
  ...gf(e),
  options: [e, t]
}), Pf = (e, t) => ({
  ...mf(e),
  options: [e, t]
}), Nf = (e, t) => ({
  ...hf(e),
  options: [e, t]
}), Af = (e, t) => ({
  ...vf(e),
  options: [e, t]
}), _f = (e, t) => ({
  ...xf(e),
  options: [e, t]
});
var Mf = "Arrow", Fa = c.forwardRef((e, t) => {
  const { children: n, width: o = 10, height: r = 5, ...a } = e;
  return /* @__PURE__ */ d(
    _.svg,
    {
      ...a,
      ref: t,
      width: o,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Fa.displayName = Mf;
var Tf = Fa, ho = "Popper", [Ba, ln] = ee(ho), [If, Va] = Ba(ho), Wa = (e) => {
  const { __scopePopper: t, children: n } = e, [o, r] = c.useState(null);
  return /* @__PURE__ */ d(If, { scope: t, anchor: o, onAnchorChange: r, children: n });
};
Wa.displayName = ho;
var Ha = "PopperAnchor", Ua = c.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: o, ...r } = e, a = Va(Ha, n), i = c.useRef(null), s = $(t, i), l = c.useRef(null);
    return c.useEffect(() => {
      const u = l.current;
      l.current = (o == null ? void 0 : o.current) || i.current, u !== l.current && a.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ d(_.div, { ...r, ref: s });
  }
);
Ua.displayName = Ha;
var vo = "PopperContent", [Df, Of] = Ba(vo), Ka = c.forwardRef(
  (e, t) => {
    var k, G, X, K, z, j;
    const {
      __scopePopper: n,
      side: o = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: p = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: v = "optimized",
      onPlaced: w,
      ...h
    } = e, g = Va(vo, n), [b, y] = c.useState(null), S = $(t, (se) => y(se)), [x, C] = c.useState(null), P = ht(x), R = (P == null ? void 0 : P.width) ?? 0, A = (P == null ? void 0 : P.height) ?? 0, M = o + (a !== "center" ? "-" + a : ""), T = typeof p == "number" ? p : { top: 0, right: 0, bottom: 0, left: 0, ...p }, O = Array.isArray(u) ? u : [u], F = O.length > 0, B = {
      padding: T,
      boundary: O.filter(Lf),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: F
    }, { refs: V, floatingStyles: U, placement: L, isPositioned: W, middlewareData: I } = Sf({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: M,
      whileElementsMounted: (...se) => df(...se, {
        animationFrame: v === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        Cf({ mainAxis: r + A, alignmentAxis: i }),
        l && Rf({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? Ef() : void 0,
          ...B
        }),
        l && Pf({ ...B }),
        Nf({
          ...B,
          apply: ({ elements: se, rects: be, availableWidth: ot, availableHeight: rt }) => {
            const { width: at, height: Gc } = be.reference, Ct = se.floating.style;
            Ct.setProperty("--radix-popper-available-width", `${ot}px`), Ct.setProperty("--radix-popper-available-height", `${rt}px`), Ct.setProperty("--radix-popper-anchor-width", `${at}px`), Ct.setProperty("--radix-popper-anchor-height", `${Gc}px`);
          }
        }),
        x && _f({ element: x, padding: s }),
        $f({ arrowWidth: R, arrowHeight: A }),
        m && Af({ strategy: "referenceHidden", ...B })
      ]
    }), [N, Y] = ja(L), q = Q(w);
    J(() => {
      W && (q == null || q());
    }, [W, q]);
    const oe = (k = I.arrow) == null ? void 0 : k.x, Pe = (G = I.arrow) == null ? void 0 : G.y, ue = ((X = I.arrow) == null ? void 0 : X.centerOffset) !== 0, [Ne, ie] = c.useState();
    return J(() => {
      b && ie(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ d(
      "div",
      {
        ref: V.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...U,
          transform: W ? U.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Ne,
          "--radix-popper-transform-origin": [
            (K = I.transformOrigin) == null ? void 0 : K.x,
            (z = I.transformOrigin) == null ? void 0 : z.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((j = I.hide) == null ? void 0 : j.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ d(
          Df,
          {
            scope: n,
            placedSide: N,
            onArrowChange: C,
            arrowX: oe,
            arrowY: Pe,
            shouldHideArrow: ue,
            children: /* @__PURE__ */ d(
              _.div,
              {
                "data-side": N,
                "data-align": Y,
                ...h,
                ref: S,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: W ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Ka.displayName = vo;
var Ga = "PopperArrow", kf = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, za = c.forwardRef(function(t, n) {
  const { __scopePopper: o, ...r } = t, a = Of(Ga, o), i = kf[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [i]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          Tf,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
za.displayName = Ga;
function Lf(e) {
  return e !== null;
}
var $f = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, b, y;
    const { placement: n, rects: o, middlewareData: r } = t, i = ((g = r.arrow) == null ? void 0 : g.centerOffset) !== 0, s = i ? 0 : e.arrowWidth, l = i ? 0 : e.arrowHeight, [u, p] = ja(n), f = { start: "0%", center: "50%", end: "100%" }[p], m = (((b = r.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, v = (((y = r.arrow) == null ? void 0 : y.y) ?? 0) + l / 2;
    let w = "", h = "";
    return u === "bottom" ? (w = i ? f : `${m}px`, h = `${-l}px`) : u === "top" ? (w = i ? f : `${m}px`, h = `${o.floating.height + l}px`) : u === "right" ? (w = `${-l}px`, h = i ? f : `${v}px`) : u === "left" && (w = `${o.floating.width + l}px`, h = i ? f : `${v}px`), { data: { x: w, y: h } };
  }
});
function ja(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var go = Wa, Ya = Ua, Xa = Ka, qa = za, Ff = "Portal", un = c.forwardRef((e, t) => {
  var s;
  const { container: n, ...o } = e, [r, a] = c.useState(!1);
  J(() => a(!0), []);
  const i = n || r && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return i ? qc.createPortal(/* @__PURE__ */ d(_.div, { ...o, ref: t }), i) : null;
});
un.displayName = Ff;
var Bf = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ke = /* @__PURE__ */ new WeakMap(), Pt = /* @__PURE__ */ new WeakMap(), Nt = {}, An = 0, Za = function(e) {
  return e && (e.host || Za(e.parentNode));
}, Vf = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var o = Za(n);
    return o && e.contains(o) ? o : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, Wf = function(e, t, n, o) {
  var r = Vf(t, Array.isArray(e) ? e : [e]);
  Nt[n] || (Nt[n] = /* @__PURE__ */ new WeakMap());
  var a = Nt[n], i = [], s = /* @__PURE__ */ new Set(), l = new Set(r), u = function(f) {
    !f || s.has(f) || (s.add(f), u(f.parentNode));
  };
  r.forEach(u);
  var p = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(m) {
      if (s.has(m))
        p(m);
      else
        try {
          var v = m.getAttribute(o), w = v !== null && v !== "false", h = (Ke.get(m) || 0) + 1, g = (a.get(m) || 0) + 1;
          Ke.set(m, h), a.set(m, g), i.push(m), h === 1 && w && Pt.set(m, !0), g === 1 && m.setAttribute(n, "true"), w || m.setAttribute(o, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", m, b);
        }
    });
  };
  return p(t), s.clear(), An++, function() {
    i.forEach(function(f) {
      var m = Ke.get(f) - 1, v = a.get(f) - 1;
      Ke.set(f, m), a.set(f, v), m || (Pt.has(f) || f.removeAttribute(o), Pt.delete(f)), v || f.removeAttribute(n);
    }), An--, An || (Ke = /* @__PURE__ */ new WeakMap(), Ke = /* @__PURE__ */ new WeakMap(), Pt = /* @__PURE__ */ new WeakMap(), Nt = {});
  };
}, wo = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), r = Bf(e);
  return r ? (o.push.apply(o, Array.from(r.querySelectorAll("[aria-live], script"))), Wf(o, r, n, "aria-hidden")) : function() {
    return null;
  };
}, ye = function() {
  return ye = Object.assign || function(t) {
    for (var n, o = 1, r = arguments.length; o < r; o++) {
      n = arguments[o];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, ye.apply(this, arguments);
};
function Qa(e, t) {
  var n = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, o = Object.getOwnPropertySymbols(e); r < o.length; r++)
      t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
  return n;
}
function Hf(e, t, n) {
  if (n || arguments.length === 2) for (var o = 0, r = t.length, a; o < r; o++)
    (a || !(o in t)) && (a || (a = Array.prototype.slice.call(t, 0, o)), a[o] = t[o]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var Tt = "right-scroll-bar-position", It = "width-before-scroll-bar", Uf = "with-scroll-bars-hidden", Kf = "--removed-body-scroll-bar-size";
function _n(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function Gf(e, t) {
  var n = Xc(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(o) {
          var r = n.value;
          r !== o && (n.value = o, n.callback(o, r));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var zf = typeof window < "u" ? c.useLayoutEffect : c.useEffect, sr = /* @__PURE__ */ new WeakMap();
function jf(e, t) {
  var n = Gf(null, function(o) {
    return e.forEach(function(r) {
      return _n(r, o);
    });
  });
  return zf(function() {
    var o = sr.get(n);
    if (o) {
      var r = new Set(o), a = new Set(e), i = n.current;
      r.forEach(function(s) {
        a.has(s) || _n(s, null);
      }), a.forEach(function(s) {
        r.has(s) || _n(s, i);
      });
    }
    sr.set(n, e);
  }, [e]), n;
}
function Yf(e) {
  return e;
}
function Xf(e, t) {
  t === void 0 && (t = Yf);
  var n = [], o = !1, r = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var i = t(a, o);
      return n.push(i), function() {
        n = n.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (o = !0; n.length; ) {
        var i = n;
        n = [], i.forEach(a);
      }
      n = {
        push: function(s) {
          return a(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      o = !0;
      var i = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(a), i = n;
      }
      var l = function() {
        var p = i;
        i = [], p.forEach(a);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(p) {
          i.push(p), u();
        },
        filter: function(p) {
          return i = i.filter(p), n;
        }
      };
    }
  };
  return r;
}
function qf(e) {
  e === void 0 && (e = {});
  var t = Xf(null);
  return t.options = ye({ async: !0, ssr: !1 }, e), t;
}
var Ja = function(e) {
  var t = e.sideCar, n = Qa(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return c.createElement(o, ye({}, n));
};
Ja.isSideCarExport = !0;
function Zf(e, t) {
  return e.useMedium(t), Ja;
}
var ei = qf(), Mn = function() {
}, dn = c.forwardRef(function(e, t) {
  var n = c.useRef(null), o = c.useState({
    onScrollCapture: Mn,
    onWheelCapture: Mn,
    onTouchMoveCapture: Mn
  }), r = o[0], a = o[1], i = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, p = e.enabled, f = e.shards, m = e.sideCar, v = e.noRelative, w = e.noIsolation, h = e.inert, g = e.allowPinchZoom, b = e.as, y = b === void 0 ? "div" : b, S = e.gapMode, x = Qa(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), C = m, P = jf([n, t]), R = ye(ye({}, x), r);
  return c.createElement(
    c.Fragment,
    null,
    p && c.createElement(C, { sideCar: ei, removeScrollBar: u, shards: f, noRelative: v, noIsolation: w, inert: h, setCallbacks: a, allowPinchZoom: !!g, lockRef: n, gapMode: S }),
    i ? c.cloneElement(c.Children.only(s), ye(ye({}, R), { ref: P })) : c.createElement(y, ye({}, R, { className: l, ref: P }), s)
  );
});
dn.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
dn.classNames = {
  fullWidth: It,
  zeroRight: Tt
};
var Qf = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Jf() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Qf();
  return t && e.setAttribute("nonce", t), e;
}
function ep(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function tp(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var np = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = Jf()) && (ep(t, n), tp(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, op = function() {
  var e = np();
  return function(t, n) {
    c.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, ti = function() {
  var e = op(), t = function(n) {
    var o = n.styles, r = n.dynamic;
    return e(o, r), null;
  };
  return t;
}, rp = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Tn = function(e) {
  return parseInt(e || "", 10) || 0;
}, ap = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], r = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Tn(n), Tn(o), Tn(r)];
}, ip = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return rp;
  var t = ap(e), n = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - n + t[2] - t[0])
  };
}, sp = ti(), Ye = "data-scroll-locked", cp = function(e, t, n, o) {
  var r = e.left, a = e.top, i = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(Uf, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Ye, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    n === "margin" && `
    padding-left: `.concat(r, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Tt, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(It, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Tt, " .").concat(Tt, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(It, " .").concat(It, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Ye, `] {
    `).concat(Kf, ": ").concat(s, `px;
  }
`);
}, cr = function() {
  var e = parseInt(document.body.getAttribute(Ye) || "0", 10);
  return isFinite(e) ? e : 0;
}, lp = function() {
  c.useEffect(function() {
    return document.body.setAttribute(Ye, (cr() + 1).toString()), function() {
      var e = cr() - 1;
      e <= 0 ? document.body.removeAttribute(Ye) : document.body.setAttribute(Ye, e.toString());
    };
  }, []);
}, up = function(e) {
  var t = e.noRelative, n = e.noImportant, o = e.gapMode, r = o === void 0 ? "margin" : o;
  lp();
  var a = c.useMemo(function() {
    return ip(r);
  }, [r]);
  return c.createElement(sp, { styles: cp(a, !t, r, n ? "" : "!important") });
}, Fn = !1;
if (typeof window < "u")
  try {
    var At = Object.defineProperty({}, "passive", {
      get: function() {
        return Fn = !0, !0;
      }
    });
    window.addEventListener("test", At, At), window.removeEventListener("test", At, At);
  } catch {
    Fn = !1;
  }
var Ge = Fn ? { passive: !1 } : !1, dp = function(e) {
  return e.tagName === "TEXTAREA";
}, ni = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !dp(e) && n[t] === "visible")
  );
}, fp = function(e) {
  return ni(e, "overflowY");
}, pp = function(e) {
  return ni(e, "overflowX");
}, lr = function(e, t) {
  var n = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var r = oi(e, o);
    if (r) {
      var a = ri(e, o), i = a[1], s = a[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== n.body);
  return !1;
}, mp = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    n,
    o
  ];
}, hp = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    n,
    o
  ];
}, oi = function(e, t) {
  return e === "v" ? fp(t) : pp(t);
}, ri = function(e, t) {
  return e === "v" ? mp(t) : hp(t);
}, vp = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, gp = function(e, t, n, o, r) {
  var a = vp(e, window.getComputedStyle(t).direction), i = a * o, s = n.target, l = t.contains(s), u = !1, p = i > 0, f = 0, m = 0;
  do {
    if (!s)
      break;
    var v = ri(e, s), w = v[0], h = v[1], g = v[2], b = h - g - a * w;
    (w || b) && oi(e, s) && (f += b, m += w);
    var y = s.parentNode;
    s = y && y.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? y.host : y;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (p && Math.abs(f) < 1 || !p && Math.abs(m) < 1) && (u = !0), u;
}, _t = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, ur = function(e) {
  return [e.deltaX, e.deltaY];
}, dr = function(e) {
  return e && "current" in e ? e.current : e;
}, wp = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, bp = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, yp = 0, ze = [];
function Sp(e) {
  var t = c.useRef([]), n = c.useRef([0, 0]), o = c.useRef(), r = c.useState(yp++)[0], a = c.useState(ti)[0], i = c.useRef(e);
  c.useEffect(function() {
    i.current = e;
  }, [e]), c.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(r));
      var h = Hf([e.lockRef.current], (e.shards || []).map(dr), !0).filter(Boolean);
      return h.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(r));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(r)), h.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(r));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = c.useCallback(function(h, g) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !i.current.allowPinchZoom;
    var b = _t(h), y = n.current, S = "deltaX" in h ? h.deltaX : y[0] - b[0], x = "deltaY" in h ? h.deltaY : y[1] - b[1], C, P = h.target, R = Math.abs(S) > Math.abs(x) ? "h" : "v";
    if ("touches" in h && R === "h" && P.type === "range")
      return !1;
    var A = lr(R, P);
    if (!A)
      return !0;
    if (A ? C = R : (C = R === "v" ? "h" : "v", A = lr(R, P)), !A)
      return !1;
    if (!o.current && "changedTouches" in h && (S || x) && (o.current = C), !C)
      return !0;
    var M = o.current || C;
    return gp(M, g, h, M === "h" ? S : x);
  }, []), l = c.useCallback(function(h) {
    var g = h;
    if (!(!ze.length || ze[ze.length - 1] !== a)) {
      var b = "deltaY" in g ? ur(g) : _t(g), y = t.current.filter(function(C) {
        return C.name === g.type && (C.target === g.target || g.target === C.shadowParent) && wp(C.delta, b);
      })[0];
      if (y && y.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!y) {
        var S = (i.current.shards || []).map(dr).filter(Boolean).filter(function(C) {
          return C.contains(g.target);
        }), x = S.length > 0 ? s(g, S[0]) : !i.current.noIsolation;
        x && g.cancelable && g.preventDefault();
      }
    }
  }, []), u = c.useCallback(function(h, g, b, y) {
    var S = { name: h, delta: g, target: b, should: y, shadowParent: xp(b) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== S;
      });
    }, 1);
  }, []), p = c.useCallback(function(h) {
    n.current = _t(h), o.current = void 0;
  }, []), f = c.useCallback(function(h) {
    u(h.type, ur(h), h.target, s(h, e.lockRef.current));
  }, []), m = c.useCallback(function(h) {
    u(h.type, _t(h), h.target, s(h, e.lockRef.current));
  }, []);
  c.useEffect(function() {
    return ze.push(a), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: m
    }), document.addEventListener("wheel", l, Ge), document.addEventListener("touchmove", l, Ge), document.addEventListener("touchstart", p, Ge), function() {
      ze = ze.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", l, Ge), document.removeEventListener("touchmove", l, Ge), document.removeEventListener("touchstart", p, Ge);
    };
  }, []);
  var v = e.removeScrollBar, w = e.inert;
  return c.createElement(
    c.Fragment,
    null,
    w ? c.createElement(a, { styles: bp(r) }) : null,
    v ? c.createElement(up, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function xp(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Cp = Zf(ei, Sp);
var fn = c.forwardRef(function(e, t) {
  return c.createElement(dn, ye({}, e, { ref: t, sideCar: Cp }));
});
fn.classNames = dn.classNames;
var Bn = ["Enter", " "], Rp = ["ArrowDown", "PageUp", "Home"], ai = ["ArrowUp", "PageDown", "End"], Ep = [...Rp, ...ai], Pp = {
  ltr: [...Bn, "ArrowRight"],
  rtl: [...Bn, "ArrowLeft"]
}, Np = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, bt = "Menu", [dt, Ap, _p] = vt(bt), [Ue, ii] = ee(bt, [
  _p,
  ln,
  Qe
]), yt = ln(), si = Qe(), [ci, Le] = Ue(bt), [Mp, St] = Ue(bt), li = (e) => {
  const { __scopeMenu: t, open: n = !1, children: o, dir: r, onOpenChange: a, modal: i = !0 } = e, s = yt(t), [l, u] = c.useState(null), p = c.useRef(!1), f = Q(a), m = ke(r);
  return c.useEffect(() => {
    const v = () => {
      p.current = !0, document.addEventListener("pointerdown", w, { capture: !0, once: !0 }), document.addEventListener("pointermove", w, { capture: !0, once: !0 });
    }, w = () => p.current = !1;
    return document.addEventListener("keydown", v, { capture: !0 }), () => {
      document.removeEventListener("keydown", v, { capture: !0 }), document.removeEventListener("pointerdown", w, { capture: !0 }), document.removeEventListener("pointermove", w, { capture: !0 });
    };
  }, []), /* @__PURE__ */ d(go, { ...s, children: /* @__PURE__ */ d(
    ci,
    {
      scope: t,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ d(
        Mp,
        {
          scope: t,
          onClose: c.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: p,
          dir: m,
          modal: i,
          children: o
        }
      )
    }
  ) });
};
li.displayName = bt;
var Tp = "MenuAnchor", bo = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = yt(n);
    return /* @__PURE__ */ d(Ya, { ...r, ...o, ref: t });
  }
);
bo.displayName = Tp;
var yo = "MenuPortal", [Ip, ui] = Ue(yo, {
  forceMount: void 0
}), di = (e) => {
  const { __scopeMenu: t, forceMount: n, children: o, container: r } = e, a = Le(yo, t);
  return /* @__PURE__ */ d(Ip, { scope: t, forceMount: n, children: /* @__PURE__ */ d(te, { present: n || a.open, children: /* @__PURE__ */ d(un, { asChild: !0, container: r, children: o }) }) });
};
di.displayName = yo;
var de = "MenuContent", [Dp, So] = Ue(de), fi = c.forwardRef(
  (e, t) => {
    const n = ui(de, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = Le(de, e.__scopeMenu), i = St(de, e.__scopeMenu);
    return /* @__PURE__ */ d(dt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ d(te, { present: o || a.open, children: /* @__PURE__ */ d(dt.Slot, { scope: e.__scopeMenu, children: i.modal ? /* @__PURE__ */ d(Op, { ...r, ref: t }) : /* @__PURE__ */ d(kp, { ...r, ref: t }) }) }) });
  }
), Op = c.forwardRef(
  (e, t) => {
    const n = Le(de, e.__scopeMenu), o = c.useRef(null), r = $(t, o);
    return c.useEffect(() => {
      const a = o.current;
      if (a) return wo(a);
    }, []), /* @__PURE__ */ d(
      xo,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: E(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), kp = c.forwardRef((e, t) => {
  const n = Le(de, e.__scopeMenu);
  return /* @__PURE__ */ d(
    xo,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Lp = /* @__PURE__ */ Xe("MenuContent.ScrollLock"), xo = c.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: o = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: i,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: u,
      onPointerDownOutside: p,
      onFocusOutside: f,
      onInteractOutside: m,
      onDismiss: v,
      disableOutsideScroll: w,
      ...h
    } = e, g = Le(de, n), b = St(de, n), y = yt(n), S = si(n), x = Ap(n), [C, P] = c.useState(null), R = c.useRef(null), A = $(t, R, g.onContentChange), M = c.useRef(0), T = c.useRef(""), O = c.useRef(0), F = c.useRef(null), B = c.useRef("right"), V = c.useRef(0), U = w ? fn : c.Fragment, L = w ? { as: Lp, allowPinchZoom: !0 } : void 0, W = (N) => {
      var k, G;
      const Y = T.current + N, q = x().filter((X) => !X.disabled), oe = document.activeElement, Pe = (k = q.find((X) => X.ref.current === oe)) == null ? void 0 : k.textValue, ue = q.map((X) => X.textValue), Ne = Yp(ue, Y, Pe), ie = (G = q.find((X) => X.textValue === Ne)) == null ? void 0 : G.ref.current;
      (function X(K) {
        T.current = K, window.clearTimeout(M.current), K !== "" && (M.current = window.setTimeout(() => X(""), 1e3));
      })(Y), ie && setTimeout(() => ie.focus());
    };
    c.useEffect(() => () => window.clearTimeout(M.current), []), so();
    const I = c.useCallback((N) => {
      var q, oe;
      return B.current === ((q = F.current) == null ? void 0 : q.side) && qp(N, (oe = F.current) == null ? void 0 : oe.area);
    }, []);
    return /* @__PURE__ */ d(
      Dp,
      {
        scope: n,
        searchRef: T,
        onItemEnter: c.useCallback(
          (N) => {
            I(N) && N.preventDefault();
          },
          [I]
        ),
        onItemLeave: c.useCallback(
          (N) => {
            var Y;
            I(N) || ((Y = R.current) == null || Y.focus(), P(null));
          },
          [I]
        ),
        onTriggerLeave: c.useCallback(
          (N) => {
            I(N) && N.preventDefault();
          },
          [I]
        ),
        pointerGraceTimerRef: O,
        onPointerGraceIntentChange: c.useCallback((N) => {
          F.current = N;
        }, []),
        children: /* @__PURE__ */ d(U, { ...L, children: /* @__PURE__ */ d(
          on,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: E(a, (N) => {
              var Y;
              N.preventDefault(), (Y = R.current) == null || Y.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: i,
            children: /* @__PURE__ */ d(
              nn,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: u,
                onPointerDownOutside: p,
                onFocusOutside: f,
                onInteractOutside: m,
                onDismiss: v,
                children: /* @__PURE__ */ d(
                  Qn,
                  {
                    asChild: !0,
                    ...S,
                    dir: b.dir,
                    orientation: "vertical",
                    loop: o,
                    currentTabStopId: C,
                    onCurrentTabStopIdChange: P,
                    onEntryFocus: E(l, (N) => {
                      b.isUsingKeyboardRef.current || N.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ d(
                      Xa,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": _i(g.open),
                        "data-radix-menu-content": "",
                        dir: b.dir,
                        ...y,
                        ...h,
                        ref: A,
                        style: { outline: "none", ...h.style },
                        onKeyDown: E(h.onKeyDown, (N) => {
                          const q = N.target.closest("[data-radix-menu-content]") === N.currentTarget, oe = N.ctrlKey || N.altKey || N.metaKey, Pe = N.key.length === 1;
                          q && (N.key === "Tab" && N.preventDefault(), !oe && Pe && W(N.key));
                          const ue = R.current;
                          if (N.target !== ue || !Ep.includes(N.key)) return;
                          N.preventDefault();
                          const ie = x().filter((k) => !k.disabled).map((k) => k.ref.current);
                          ai.includes(N.key) && ie.reverse(), zp(ie);
                        }),
                        onBlur: E(e.onBlur, (N) => {
                          N.currentTarget.contains(N.target) || (window.clearTimeout(M.current), T.current = "");
                        }),
                        onPointerMove: E(
                          e.onPointerMove,
                          ft((N) => {
                            const Y = N.target, q = V.current !== N.clientX;
                            if (N.currentTarget.contains(Y) && q) {
                              const oe = N.clientX > V.current ? "right" : "left";
                              B.current = oe, V.current = N.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
fi.displayName = de;
var $p = "MenuGroup", Co = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ d(_.div, { role: "group", ...o, ref: t });
  }
);
Co.displayName = $p;
var Fp = "MenuLabel", pi = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ d(_.div, { ...o, ref: t });
  }
);
pi.displayName = Fp;
var Wt = "MenuItem", fr = "menu.itemSelect", pn = c.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: o, ...r } = e, a = c.useRef(null), i = St(Wt, e.__scopeMenu), s = So(Wt, e.__scopeMenu), l = $(t, a), u = c.useRef(!1), p = () => {
      const f = a.current;
      if (!n && f) {
        const m = new CustomEvent(fr, { bubbles: !0, cancelable: !0 });
        f.addEventListener(fr, (v) => o == null ? void 0 : o(v), { once: !0 }), hr(f, m), m.defaultPrevented ? u.current = !1 : i.onClose();
      }
    };
    return /* @__PURE__ */ d(
      mi,
      {
        ...r,
        ref: l,
        disabled: n,
        onClick: E(e.onClick, p),
        onPointerDown: (f) => {
          var m;
          (m = e.onPointerDown) == null || m.call(e, f), u.current = !0;
        },
        onPointerUp: E(e.onPointerUp, (f) => {
          var m;
          u.current || (m = f.currentTarget) == null || m.click();
        }),
        onKeyDown: E(e.onKeyDown, (f) => {
          const m = s.searchRef.current !== "";
          n || m && f.key === " " || Bn.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
pn.displayName = Wt;
var mi = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: o = !1, textValue: r, ...a } = e, i = So(Wt, n), s = si(n), l = c.useRef(null), u = $(t, l), [p, f] = c.useState(!1), [m, v] = c.useState("");
    return c.useEffect(() => {
      const w = l.current;
      w && v((w.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ d(
      dt.ItemSlot,
      {
        scope: n,
        disabled: o,
        textValue: r ?? m,
        children: /* @__PURE__ */ d(Jn, { asChild: !0, ...s, focusable: !o, children: /* @__PURE__ */ d(
          _.div,
          {
            role: "menuitem",
            "data-highlighted": p ? "" : void 0,
            "aria-disabled": o || void 0,
            "data-disabled": o ? "" : void 0,
            ...a,
            ref: u,
            onPointerMove: E(
              e.onPointerMove,
              ft((w) => {
                o ? i.onItemLeave(w) : (i.onItemEnter(w), w.defaultPrevented || w.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: E(
              e.onPointerLeave,
              ft((w) => i.onItemLeave(w))
            ),
            onFocus: E(e.onFocus, () => f(!0)),
            onBlur: E(e.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), Bp = "MenuCheckboxItem", hi = c.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: o, ...r } = e;
    return /* @__PURE__ */ d(yi, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ d(
      pn,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ht(n) ? "mixed" : n,
        ...r,
        ref: t,
        "data-state": Po(n),
        onSelect: E(
          r.onSelect,
          () => o == null ? void 0 : o(Ht(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
hi.displayName = Bp;
var vi = "MenuRadioGroup", [Vp, Wp] = Ue(
  vi,
  { value: void 0, onValueChange: () => {
  } }
), gi = c.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: o, ...r } = e, a = Q(o);
    return /* @__PURE__ */ d(Vp, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ d(Co, { ...r, ref: t }) });
  }
);
gi.displayName = vi;
var wi = "MenuRadioItem", bi = c.forwardRef(
  (e, t) => {
    const { value: n, ...o } = e, r = Wp(wi, e.__scopeMenu), a = n === r.value;
    return /* @__PURE__ */ d(yi, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ d(
      pn,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...o,
        ref: t,
        "data-state": Po(a),
        onSelect: E(
          o.onSelect,
          () => {
            var i;
            return (i = r.onValueChange) == null ? void 0 : i.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
bi.displayName = wi;
var Ro = "MenuItemIndicator", [yi, Hp] = Ue(
  Ro,
  { checked: !1 }
), Si = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: o, ...r } = e, a = Hp(Ro, n);
    return /* @__PURE__ */ d(
      te,
      {
        present: o || Ht(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ d(
          _.span,
          {
            ...r,
            ref: t,
            "data-state": Po(a.checked)
          }
        )
      }
    );
  }
);
Si.displayName = Ro;
var Up = "MenuSeparator", xi = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e;
    return /* @__PURE__ */ d(
      _.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...o,
        ref: t
      }
    );
  }
);
xi.displayName = Up;
var Kp = "MenuArrow", Ci = c.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...o } = e, r = yt(n);
    return /* @__PURE__ */ d(qa, { ...r, ...o, ref: t });
  }
);
Ci.displayName = Kp;
var Eo = "MenuSub", [Gp, Ri] = Ue(Eo), Ei = (e) => {
  const { __scopeMenu: t, children: n, open: o = !1, onOpenChange: r } = e, a = Le(Eo, t), i = yt(t), [s, l] = c.useState(null), [u, p] = c.useState(null), f = Q(r);
  return c.useEffect(() => (a.open === !1 && f(!1), () => f(!1)), [a.open, f]), /* @__PURE__ */ d(go, { ...i, children: /* @__PURE__ */ d(
    ci,
    {
      scope: t,
      open: o,
      onOpenChange: f,
      content: u,
      onContentChange: p,
      children: /* @__PURE__ */ d(
        Gp,
        {
          scope: t,
          contentId: re(),
          triggerId: re(),
          trigger: s,
          onTriggerChange: l,
          children: n
        }
      )
    }
  ) });
};
Ei.displayName = Eo;
var it = "MenuSubTrigger", Pi = c.forwardRef(
  (e, t) => {
    const n = Le(it, e.__scopeMenu), o = St(it, e.__scopeMenu), r = Ri(it, e.__scopeMenu), a = So(it, e.__scopeMenu), i = c.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = a, u = { __scopeMenu: e.__scopeMenu }, p = c.useCallback(() => {
      i.current && window.clearTimeout(i.current), i.current = null;
    }, []);
    return c.useEffect(() => p, [p]), c.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [s, l]), /* @__PURE__ */ d(bo, { asChild: !0, ...u, children: /* @__PURE__ */ d(
      mi,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": _i(n.open),
        ...e,
        ref: pt(t, r.onTriggerChange),
        onClick: (f) => {
          var m;
          (m = e.onClick) == null || m.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: E(
          e.onPointerMove,
          ft((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !i.current && (a.onPointerGraceIntentChange(null), i.current = window.setTimeout(() => {
              n.onOpenChange(!0), p();
            }, 100));
          })
        ),
        onPointerLeave: E(
          e.onPointerLeave,
          ft((f) => {
            var v, w;
            p();
            const m = (v = n.content) == null ? void 0 : v.getBoundingClientRect();
            if (m) {
              const h = (w = n.content) == null ? void 0 : w.dataset.side, g = h === "right", b = g ? -5 : 5, y = m[g ? "left" : "right"], S = m[g ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + b, y: f.clientY },
                  { x: y, y: m.top },
                  { x: S, y: m.top },
                  { x: S, y: m.bottom },
                  { x: y, y: m.bottom }
                ],
                side: h
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: E(e.onKeyDown, (f) => {
          var v;
          const m = a.searchRef.current !== "";
          e.disabled || m && f.key === " " || Pp[o.dir].includes(f.key) && (n.onOpenChange(!0), (v = n.content) == null || v.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
Pi.displayName = it;
var Ni = "MenuSubContent", Ai = c.forwardRef(
  (e, t) => {
    const n = ui(de, e.__scopeMenu), { forceMount: o = n.forceMount, ...r } = e, a = Le(de, e.__scopeMenu), i = St(de, e.__scopeMenu), s = Ri(Ni, e.__scopeMenu), l = c.useRef(null), u = $(t, l);
    return /* @__PURE__ */ d(dt.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ d(te, { present: o || a.open, children: /* @__PURE__ */ d(dt.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ d(
      xo,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...r,
        ref: u,
        align: "start",
        side: i.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (p) => {
          var f;
          i.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), p.preventDefault();
        },
        onCloseAutoFocus: (p) => p.preventDefault(),
        onFocusOutside: E(e.onFocusOutside, (p) => {
          p.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: E(e.onEscapeKeyDown, (p) => {
          i.onClose(), p.preventDefault();
        }),
        onKeyDown: E(e.onKeyDown, (p) => {
          var v;
          const f = p.currentTarget.contains(p.target), m = Np[i.dir].includes(p.key);
          f && m && (a.onOpenChange(!1), (v = s.trigger) == null || v.focus(), p.preventDefault());
        })
      }
    ) }) }) });
  }
);
Ai.displayName = Ni;
function _i(e) {
  return e ? "open" : "closed";
}
function Ht(e) {
  return e === "indeterminate";
}
function Po(e) {
  return Ht(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function zp(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function jp(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
function Yp(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = jp(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const l = i.find(
    (u) => u.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Xp(e, t) {
  const { x: n, y: o } = e;
  let r = !1;
  for (let a = 0, i = t.length - 1; a < t.length; i = a++) {
    const s = t[a], l = t[i], u = s.x, p = s.y, f = l.x, m = l.y;
    p > o != m > o && n < (f - u) * (o - p) / (m - p) + u && (r = !r);
  }
  return r;
}
function qp(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Xp(n, t);
}
function ft(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Zp = li, Qp = bo, Jp = di, em = fi, tm = Co, nm = pi, om = pn, rm = hi, am = gi, im = bi, sm = Si, cm = xi, lm = Ci, um = Ei, dm = Pi, fm = Ai, mn = "DropdownMenu", [pm] = ee(
  mn,
  [ii]
), ne = ii(), [mm, Mi] = pm(mn), Ti = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: o,
    open: r,
    defaultOpen: a,
    onOpenChange: i,
    modal: s = !0
  } = e, l = ne(t), u = c.useRef(null), [p, f] = ae({
    prop: r,
    defaultProp: a ?? !1,
    onChange: i,
    caller: mn
  });
  return /* @__PURE__ */ d(
    mm,
    {
      scope: t,
      triggerId: re(),
      triggerRef: u,
      contentId: re(),
      open: p,
      onOpenChange: f,
      onOpenToggle: c.useCallback(() => f((m) => !m), [f]),
      modal: s,
      children: /* @__PURE__ */ d(Zp, { ...l, open: p, onOpenChange: f, dir: o, modal: s, children: n })
    }
  );
};
Ti.displayName = mn;
var Ii = "DropdownMenuTrigger", Di = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: o = !1, ...r } = e, a = Mi(Ii, n), i = ne(n);
    return /* @__PURE__ */ d(Qp, { asChild: !0, ...i, children: /* @__PURE__ */ d(
      _.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": o ? "" : void 0,
        disabled: o,
        ...r,
        ref: pt(t, a.triggerRef),
        onPointerDown: E(e.onPointerDown, (s) => {
          !o && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: E(e.onKeyDown, (s) => {
          o || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
Di.displayName = Ii;
var hm = "DropdownMenuPortal", Oi = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, o = ne(t);
  return /* @__PURE__ */ d(Jp, { ...o, ...n });
};
Oi.displayName = hm;
var ki = "DropdownMenuContent", Li = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = Mi(ki, n), a = ne(n), i = c.useRef(!1);
    return /* @__PURE__ */ d(
      em,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...o,
        ref: t,
        onCloseAutoFocus: E(e.onCloseAutoFocus, (s) => {
          var l;
          i.current || (l = r.triggerRef.current) == null || l.focus(), i.current = !1, s.preventDefault();
        }),
        onInteractOutside: E(e.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, p = l.button === 2 || u;
          (!r.modal || p) && (i.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Li.displayName = ki;
var vm = "DropdownMenuGroup", $i = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
    return /* @__PURE__ */ d(tm, { ...r, ...o, ref: t });
  }
);
$i.displayName = vm;
var gm = "DropdownMenuLabel", Fi = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
    return /* @__PURE__ */ d(nm, { ...r, ...o, ref: t });
  }
);
Fi.displayName = gm;
var wm = "DropdownMenuItem", Bi = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
    return /* @__PURE__ */ d(om, { ...r, ...o, ref: t });
  }
);
Bi.displayName = wm;
var bm = "DropdownMenuCheckboxItem", Vi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(rm, { ...r, ...o, ref: t });
});
Vi.displayName = bm;
var ym = "DropdownMenuRadioGroup", Wi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(am, { ...r, ...o, ref: t });
});
Wi.displayName = ym;
var Sm = "DropdownMenuRadioItem", Hi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(im, { ...r, ...o, ref: t });
});
Hi.displayName = Sm;
var xm = "DropdownMenuItemIndicator", Ui = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(sm, { ...r, ...o, ref: t });
});
Ui.displayName = xm;
var Cm = "DropdownMenuSeparator", Ki = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(cm, { ...r, ...o, ref: t });
});
Ki.displayName = Cm;
var Rm = "DropdownMenuArrow", Em = c.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
    return /* @__PURE__ */ d(lm, { ...r, ...o, ref: t });
  }
);
Em.displayName = Rm;
var Pm = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: o, onOpenChange: r, defaultOpen: a } = e, i = ne(t), [s, l] = ae({
    prop: o,
    defaultProp: a ?? !1,
    onChange: r,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ d(um, { ...i, open: s, onOpenChange: l, children: n });
}, Nm = "DropdownMenuSubTrigger", Gi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(dm, { ...r, ...o, ref: t });
});
Gi.displayName = Nm;
var Am = "DropdownMenuSubContent", zi = c.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...o } = e, r = ne(n);
  return /* @__PURE__ */ d(
    fm,
    {
      ...r,
      ...o,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
zi.displayName = Am;
var _m = Ti, Mm = Di, ji = Oi, Yi = Li, Tm = $i, Xi = Fi, qi = Bi, Zi = Vi, Im = Wi, Qi = Hi, Ji = Ui, es = Ki, Dm = Pm, ts = Gi, ns = zi;
const $v = _m, Fv = Mm, Bv = Tm, Vv = ji, Wv = Dm, Hv = Im, Om = c.forwardRef(({ className: e, inset: t, children: n, ...o }, r) => /* @__PURE__ */ H(
  ts,
  {
    ref: r,
    className: D(
      "flex cursor-default gap-2 select-none items-center rounded-sm px-2 py-1.5 text-sm outline-none focus:bg-accent data-[state=open]:bg-accent [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...o,
    children: [
      n,
      /* @__PURE__ */ d(zu, { className: "ml-auto" })
    ]
  }
));
Om.displayName = ts.displayName;
const km = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  ns,
  {
    ref: n,
    className: D(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-white p-1 text-popover-foreground shadow-lg data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
km.displayName = ns.displayName;
const Lm = c.forwardRef(({ className: e, sideOffset: t = 4, ...n }, o) => /* @__PURE__ */ d(ji, { children: /* @__PURE__ */ d(
  Yi,
  {
    ref: o,
    sideOffset: t,
    className: D(
      "z-50 min-w-[8rem] overflow-hidden rounded-md border bg-white p-1 text-popover-foreground shadow-md",
      "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...n
  }
) }));
Lm.displayName = Yi.displayName;
const $m = c.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ d(
  qi,
  {
    ref: o,
    className: D(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
      t && "pl-8",
      e
    ),
    ...n
  }
));
$m.displayName = qi.displayName;
const Fm = c.forwardRef(({ className: e, children: t, checked: n, ...o }, r) => /* @__PURE__ */ H(
  Zi,
  {
    ref: r,
    className: D(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    checked: n,
    ...o,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(Ji, { children: /* @__PURE__ */ d(tn, { className: "h-4 w-4" }) }) }),
      t
    ]
  }
));
Fm.displayName = Zi.displayName;
const Bm = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ H(
  Qi,
  {
    ref: o,
    className: D(
      "relative flex cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(Ji, { children: /* @__PURE__ */ d(ju, { className: "h-2 w-2 fill-current" }) }) }),
      t
    ]
  }
));
Bm.displayName = Qi.displayName;
const Vm = c.forwardRef(({ className: e, inset: t, ...n }, o) => /* @__PURE__ */ d(
  Xi,
  {
    ref: o,
    className: D("px-2 py-1.5 text-sm font-semibold", t && "pl-8", e),
    ...n
  }
));
Vm.displayName = Xi.displayName;
const Wm = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  es,
  {
    ref: n,
    className: D("-mx-1 my-1 h-px bg-muted", e),
    ...t
  }
));
Wm.displayName = es.displayName;
const Hm = ({ className: e, ...t }) => /* @__PURE__ */ d("span", { className: D("ml-auto text-xs tracking-widest opacity-60", e), ...t });
Hm.displayName = "DropdownMenuShortcut";
var hn = "Dialog", [os] = ee(hn), [Um, we] = os(hn), rs = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    modal: i = !0
  } = e, s = c.useRef(null), l = c.useRef(null), [u, p] = ae({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: hn
  });
  return /* @__PURE__ */ d(
    Um,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: re(),
      titleId: re(),
      descriptionId: re(),
      open: u,
      onOpenChange: p,
      onOpenToggle: c.useCallback(() => p((f) => !f), [p]),
      modal: i,
      children: n
    }
  );
};
rs.displayName = hn;
var as = "DialogTrigger", is = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = we(as, n), a = $(t, r.triggerRef);
    return /* @__PURE__ */ d(
      _.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": r.open,
        "aria-controls": r.contentId,
        "data-state": _o(r.open),
        ...o,
        ref: a,
        onClick: E(e.onClick, r.onOpenToggle)
      }
    );
  }
);
is.displayName = as;
var No = "DialogPortal", [Km, ss] = os(No, {
  forceMount: void 0
}), cs = (e) => {
  const { __scopeDialog: t, forceMount: n, children: o, container: r } = e, a = we(No, t);
  return /* @__PURE__ */ d(Km, { scope: t, forceMount: n, children: c.Children.map(o, (i) => /* @__PURE__ */ d(te, { present: n || a.open, children: /* @__PURE__ */ d(un, { asChild: !0, container: r, children: i }) })) });
};
cs.displayName = No;
var Ut = "DialogOverlay", ls = c.forwardRef(
  (e, t) => {
    const n = ss(Ut, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = we(Ut, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ d(te, { present: o || a.open, children: /* @__PURE__ */ d(zm, { ...r, ref: t }) }) : null;
  }
);
ls.displayName = Ut;
var Gm = /* @__PURE__ */ Xe("DialogOverlay.RemoveScroll"), zm = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = we(Ut, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ d(fn, { as: Gm, allowPinchZoom: !0, shards: [r.contentRef], children: /* @__PURE__ */ d(
        _.div,
        {
          "data-state": _o(r.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), Ve = "DialogContent", us = c.forwardRef(
  (e, t) => {
    const n = ss(Ve, e.__scopeDialog), { forceMount: o = n.forceMount, ...r } = e, a = we(Ve, e.__scopeDialog);
    return /* @__PURE__ */ d(te, { present: o || a.open, children: a.modal ? /* @__PURE__ */ d(jm, { ...r, ref: t }) : /* @__PURE__ */ d(Ym, { ...r, ref: t }) });
  }
);
us.displayName = Ve;
var jm = c.forwardRef(
  (e, t) => {
    const n = we(Ve, e.__scopeDialog), o = c.useRef(null), r = $(t, n.contentRef, o);
    return c.useEffect(() => {
      const a = o.current;
      if (a) return wo(a);
    }, []), /* @__PURE__ */ d(
      ds,
      {
        ...e,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: E(e.onCloseAutoFocus, (a) => {
          var i;
          a.preventDefault(), (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: E(e.onPointerDownOutside, (a) => {
          const i = a.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && a.preventDefault();
        }),
        onFocusOutside: E(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), Ym = c.forwardRef(
  (e, t) => {
    const n = we(Ve, e.__scopeDialog), o = c.useRef(!1), r = c.useRef(!1);
    return /* @__PURE__ */ d(
      ds,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var i, s;
          (i = e.onCloseAutoFocus) == null || i.call(e, a), a.defaultPrevented || (o.current || (s = n.triggerRef.current) == null || s.focus(), a.preventDefault()), o.current = !1, r.current = !1;
        },
        onInteractOutside: (a) => {
          var l, u;
          (l = e.onInteractOutside) == null || l.call(e, a), a.defaultPrevented || (o.current = !0, a.detail.originalEvent.type === "pointerdown" && (r.current = !0));
          const i = a.target;
          ((u = n.triggerRef.current) == null ? void 0 : u.contains(i)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && r.current && a.preventDefault();
        }
      }
    );
  }
), ds = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: o, onOpenAutoFocus: r, onCloseAutoFocus: a, ...i } = e, s = we(Ve, n), l = c.useRef(null), u = $(t, l);
    return so(), /* @__PURE__ */ H(Ae, { children: [
      /* @__PURE__ */ d(
        on,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: r,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ d(
            nn,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": _o(s.open),
              ...i,
              ref: u,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ H(Ae, { children: [
        /* @__PURE__ */ d(Xm, { titleId: s.titleId }),
        /* @__PURE__ */ d(Zm, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ao = "DialogTitle", fs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = we(Ao, n);
    return /* @__PURE__ */ d(_.h2, { id: r.titleId, ...o, ref: t });
  }
);
fs.displayName = Ao;
var ps = "DialogDescription", ms = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = we(ps, n);
    return /* @__PURE__ */ d(_.p, { id: r.descriptionId, ...o, ref: t });
  }
);
ms.displayName = ps;
var hs = "DialogClose", vs = c.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...o } = e, r = we(hs, n);
    return /* @__PURE__ */ d(
      _.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: E(e.onClick, () => r.onOpenChange(!1))
      }
    );
  }
);
vs.displayName = hs;
function _o(e) {
  return e ? "open" : "closed";
}
var gs = "DialogTitleWarning", [Uv, ws] = cl(gs, {
  contentName: Ve,
  titleName: Ao,
  docsSlug: "dialog"
}), Xm = ({ titleId: e }) => {
  const t = ws(gs), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return c.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, qm = "DialogDescriptionWarning", Zm = ({ contentRef: e, descriptionId: t }) => {
  const o = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${ws(qm).contentName}}.`;
  return c.useEffect(() => {
    var a;
    const r = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && r && (document.getElementById(t) || console.warn(o));
  }, [o, e, t]), null;
}, Qm = rs, Jm = is, eh = cs, bs = ls, ys = us, Ss = fs, xs = ms, Cs = vs;
const Kv = Qm, Gv = Jm, th = eh, zv = Cs, Rs = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  bs,
  {
    ref: n,
    className: D(
      "fixed inset-0 z-50 bg-black/80 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0",
      e
    ),
    ...t
  }
));
Rs.displayName = bs.displayName;
const nh = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ H(th, { children: [
  /* @__PURE__ */ d(Rs, {}),
  /* @__PURE__ */ H(
    ys,
    {
      ref: o,
      className: D(
        "fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-white p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] sm:rounded-lg",
        e
      ),
      ...n,
      children: [
        t,
        /* @__PURE__ */ H(Cs, { className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ d(ed, { className: "h-4 w-4" }),
          /* @__PURE__ */ d("span", { className: "sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
nh.displayName = ys.displayName;
const oh = ({ className: e, ...t }) => /* @__PURE__ */ d("div", { className: D("flex flex-col space-y-1.5 text-center sm:text-left", e), ...t });
oh.displayName = "DialogHeader";
const rh = ({ className: e, ...t }) => /* @__PURE__ */ d(
  "div",
  {
    className: D("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", e),
    ...t
  }
);
rh.displayName = "DialogFooter";
const ah = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Ss,
  {
    ref: n,
    className: D("text-lg font-semibold leading-none tracking-tight", e),
    ...t
  }
));
ah.displayName = Ss.displayName;
const ih = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  xs,
  {
    ref: n,
    className: D("text-sm text-muted-foreground", e),
    ...t
  }
));
ih.displayName = xs.displayName;
function sh(e, t = []) {
  let n = [];
  function o(a, i) {
    const s = c.createContext(i);
    s.displayName = a + "Context";
    const l = n.length;
    n = [...n, i];
    const u = (f) => {
      var b;
      const { scope: m, children: v, ...w } = f, h = ((b = m == null ? void 0 : m[e]) == null ? void 0 : b[l]) || s, g = c.useMemo(() => w, Object.values(w));
      return /* @__PURE__ */ d(h.Provider, { value: g, children: v });
    };
    u.displayName = a + "Provider";
    function p(f, m) {
      var h;
      const v = ((h = m == null ? void 0 : m[e]) == null ? void 0 : h[l]) || s, w = c.useContext(v);
      if (w) return w;
      if (i !== void 0) return i;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [u, p];
  }
  const r = () => {
    const a = n.map((i) => c.createContext(i));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || a;
      return c.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return r.scopeName = e, [o, ch(r, ...t)];
}
function ch(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const o = e.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const i = o.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(a)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return c.useMemo(() => ({ [`__scope${t.scopeName}`]: i }), [i]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Mo = "Progress", To = 100, [lh] = sh(Mo), [uh, dh] = lh(Mo), Es = c.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: n,
      value: o = null,
      max: r,
      getValueLabel: a = fh,
      ...i
    } = e;
    (r || r === 0) && !pr(r) && console.error(ph(`${r}`, "Progress"));
    const s = pr(r) ? r : To;
    o !== null && !mr(o, s) && console.error(mh(`${o}`, "Progress"));
    const l = mr(o, s) ? o : null, u = Kt(l) ? a(l, s) : void 0;
    return /* @__PURE__ */ d(uh, { scope: n, value: l, max: s, children: /* @__PURE__ */ d(
      Zt.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": Kt(l) ? l : void 0,
        "aria-valuetext": u,
        role: "progressbar",
        "data-state": As(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
Es.displayName = Mo;
var Ps = "ProgressIndicator", Ns = c.forwardRef(
  (e, t) => {
    const { __scopeProgress: n, ...o } = e, r = dh(Ps, n);
    return /* @__PURE__ */ d(
      Zt.div,
      {
        "data-state": As(r.value, r.max),
        "data-value": r.value ?? void 0,
        "data-max": r.max,
        ...o,
        ref: t
      }
    );
  }
);
Ns.displayName = Ps;
function fh(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function As(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function Kt(e) {
  return typeof e == "number";
}
function pr(e) {
  return Kt(e) && !isNaN(e) && e > 0;
}
function mr(e, t) {
  return Kt(e) && !isNaN(e) && e <= t && e >= 0;
}
function ph(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${To}\`.`;
}
function mh(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${To} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var _s = Es, hh = Ns;
const vh = c.forwardRef(({ className: e, value: t, ...n }, o) => /* @__PURE__ */ d(
  _s,
  {
    ref: o,
    className: D(
      "relative h-4 w-full overflow-hidden rounded-full bg-secondary",
      e
    ),
    ...n,
    children: /* @__PURE__ */ d(
      hh,
      {
        className: "h-full w-full flex-1 bg-primary transition-all",
        style: { transform: `translateX(-${100 - (t || 0)}%)` }
      }
    )
  }
));
vh.displayName = _s.displayName;
const xt = c.forwardRef(
  ({ className: e, variant: t = "default", size: n = "default", ...o }, r) => {
    const a = {
      default: "bg-blue-600 text-white hover:bg-blue-700",
      destructive: "bg-red-600 text-white hover:bg-red-700",
      outline: "border border-gray-300 bg-transparent hover:bg-gray-100",
      secondary: "bg-gray-600 text-white hover:bg-gray-700",
      ghost: "hover:bg-gray-100",
      link: "text-blue-600 underline-offset-4 hover:underline"
    }, i = {
      default: "h-10 px-4 py-2",
      sm: "h-9 rounded-md px-3",
      lg: "h-11 rounded-md px-8",
      icon: "h-10 w-10"
    };
    return /* @__PURE__ */ d(
      "button",
      {
        className: D(
          "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
          a[t],
          i[n],
          e
        ),
        ref: r,
        ...o
      }
    );
  }
);
xt.displayName = "Button";
const Ms = c.forwardRef(
  ({ className: e, type: t, ...n }, o) => /* @__PURE__ */ d(
    "input",
    {
      type: t,
      className: D(
        "flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: o,
      ...n
    }
  )
);
Ms.displayName = "Input";
var gh = "Label", Ts = c.forwardRef((e, t) => /* @__PURE__ */ d(
  Zt.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var r;
      n.target.closest("button, input, select, textarea") || ((r = e.onMouseDown) == null || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Ts.displayName = gh;
var Is = Ts;
const Ds = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Is,
  {
    ref: n,
    className: D(
      "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
      e
    ),
    ...t
  }
));
Ds.displayName = Is.displayName;
function jv({ className: e, variant: t = "default", ...n }) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: D(
        "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors",
        {
          default: "bg-blue-100 text-blue-900 hover:bg-blue-200",
          secondary: "bg-gray-100 text-gray-900 hover:bg-gray-200",
          destructive: "bg-red-100 text-red-900 hover:bg-red-200",
          outline: "text-gray-900 border border-gray-200"
        }[t],
        e
      ),
      ...n
    }
  );
}
var vn = "Checkbox", [wh] = ee(vn), [bh, Io] = wh(vn);
function yh(e) {
  const {
    __scopeCheckbox: t,
    checked: n,
    children: o,
    defaultChecked: r,
    disabled: a,
    form: i,
    name: s,
    onCheckedChange: l,
    required: u,
    value: p = "on",
    // @ts-expect-error
    internal_do_not_use_render: f
  } = e, [m, v] = ae({
    prop: n,
    defaultProp: r ?? !1,
    onChange: l,
    caller: vn
  }), [w, h] = c.useState(null), [g, b] = c.useState(null), y = c.useRef(!1), S = w ? !!i || !!w.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), x = {
    checked: m,
    disabled: a,
    setChecked: v,
    control: w,
    setControl: h,
    name: s,
    form: i,
    value: p,
    hasConsumerStoppedPropagationRef: y,
    required: u,
    defaultChecked: Ie(r) ? !1 : r,
    isFormControl: S,
    bubbleInput: g,
    setBubbleInput: b
  };
  return /* @__PURE__ */ d(
    bh,
    {
      scope: t,
      ...x,
      children: Sh(f) ? f(x) : o
    }
  );
}
var Os = "CheckboxTrigger", ks = c.forwardRef(
  ({ __scopeCheckbox: e, onKeyDown: t, onClick: n, ...o }, r) => {
    const {
      control: a,
      value: i,
      disabled: s,
      checked: l,
      required: u,
      setControl: p,
      setChecked: f,
      hasConsumerStoppedPropagationRef: m,
      isFormControl: v,
      bubbleInput: w
    } = Io(Os, e), h = $(r, p), g = c.useRef(l);
    return c.useEffect(() => {
      const b = a == null ? void 0 : a.form;
      if (b) {
        const y = () => f(g.current);
        return b.addEventListener("reset", y), () => b.removeEventListener("reset", y);
      }
    }, [a, f]), /* @__PURE__ */ d(
      _.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": Ie(l) ? "mixed" : l,
        "aria-required": u,
        "data-state": Vs(l),
        "data-disabled": s ? "" : void 0,
        disabled: s,
        value: i,
        ...o,
        ref: h,
        onKeyDown: E(t, (b) => {
          b.key === "Enter" && b.preventDefault();
        }),
        onClick: E(n, (b) => {
          f((y) => Ie(y) ? !0 : !y), w && v && (m.current = b.isPropagationStopped(), m.current || b.stopPropagation());
        })
      }
    );
  }
);
ks.displayName = Os;
var Do = c.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: n,
      name: o,
      checked: r,
      defaultChecked: a,
      required: i,
      disabled: s,
      value: l,
      onCheckedChange: u,
      form: p,
      ...f
    } = e;
    return /* @__PURE__ */ d(
      yh,
      {
        __scopeCheckbox: n,
        checked: r,
        defaultChecked: a,
        disabled: s,
        required: i,
        onCheckedChange: u,
        name: o,
        form: p,
        value: l,
        internal_do_not_use_render: ({ isFormControl: m }) => /* @__PURE__ */ H(Ae, { children: [
          /* @__PURE__ */ d(
            ks,
            {
              ...f,
              ref: t,
              __scopeCheckbox: n
            }
          ),
          m && /* @__PURE__ */ d(
            Bs,
            {
              __scopeCheckbox: n
            }
          )
        ] })
      }
    );
  }
);
Do.displayName = vn;
var Ls = "CheckboxIndicator", $s = c.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: n, forceMount: o, ...r } = e, a = Io(Ls, n);
    return /* @__PURE__ */ d(
      te,
      {
        present: o || Ie(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ d(
          _.span,
          {
            "data-state": Vs(a.checked),
            "data-disabled": a.disabled ? "" : void 0,
            ...r,
            ref: t,
            style: { pointerEvents: "none", ...e.style }
          }
        )
      }
    );
  }
);
$s.displayName = Ls;
var Fs = "CheckboxBubbleInput", Bs = c.forwardRef(
  ({ __scopeCheckbox: e, ...t }, n) => {
    const {
      control: o,
      hasConsumerStoppedPropagationRef: r,
      checked: a,
      defaultChecked: i,
      required: s,
      disabled: l,
      name: u,
      value: p,
      form: f,
      bubbleInput: m,
      setBubbleInput: v
    } = Io(Fs, e), w = $(n, v), h = mt(a), g = ht(o);
    c.useEffect(() => {
      const y = m;
      if (!y) return;
      const S = window.HTMLInputElement.prototype, C = Object.getOwnPropertyDescriptor(
        S,
        "checked"
      ).set, P = !r.current;
      if (h !== a && C) {
        const R = new Event("click", { bubbles: P });
        y.indeterminate = Ie(a), C.call(y, Ie(a) ? !1 : a), y.dispatchEvent(R);
      }
    }, [m, h, a, r]);
    const b = c.useRef(Ie(a) ? !1 : a);
    return /* @__PURE__ */ d(
      _.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: i ?? b.current,
        required: s,
        disabled: l,
        name: u,
        value: p,
        form: f,
        ...t,
        tabIndex: -1,
        ref: w,
        style: {
          ...t.style,
          ...g,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
Bs.displayName = Fs;
function Sh(e) {
  return typeof e == "function";
}
function Ie(e) {
  return e === "indeterminate";
}
function Vs(e) {
  return Ie(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const xh = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Do,
  {
    ref: n,
    className: D(
      "peer h-4 w-4 shrink-0 rounded-sm border border-gray-300 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-blue-600 data-[state=checked]:text-white",
      e
    ),
    ...t,
    children: /* @__PURE__ */ d(
      $s,
      {
        className: D("flex items-center justify-center text-current"),
        children: /* @__PURE__ */ d(tn, { className: "h-4 w-4" })
      }
    )
  }
));
xh.displayName = Do.displayName;
const Ch = c.forwardRef(
  ({ className: e, ...t }, n) => /* @__PURE__ */ d(
    "textarea",
    {
      className: D(
        "flex min-h-[80px] w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
        e
      ),
      ref: n,
      ...t
    }
  )
);
Ch.displayName = "Textarea";
var Ws = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Rh = "VisuallyHidden", Eh = c.forwardRef(
  (e, t) => /* @__PURE__ */ d(
    _.span,
    {
      ...e,
      ref: t,
      style: { ...Ws, ...e.style }
    }
  )
);
Eh.displayName = Rh;
var Ph = [" ", "Enter", "ArrowUp", "ArrowDown"], Nh = [" ", "Enter"], We = "Select", [gn, wn, Ah] = vt(We), [tt] = ee(We, [
  Ah,
  ln
]), bn = ln(), [_h, $e] = tt(We), [Mh, Th] = tt(We), Hs = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: o,
    defaultOpen: r,
    onOpenChange: a,
    value: i,
    defaultValue: s,
    onValueChange: l,
    dir: u,
    name: p,
    autoComplete: f,
    disabled: m,
    required: v,
    form: w
  } = e, h = bn(t), [g, b] = c.useState(null), [y, S] = c.useState(null), [x, C] = c.useState(!1), P = ke(u), [R, A] = ae({
    prop: o,
    defaultProp: r ?? !1,
    onChange: a,
    caller: We
  }), [M, T] = ae({
    prop: i,
    defaultProp: s,
    onChange: l,
    caller: We
  }), O = c.useRef(null), F = g ? w || !!g.closest("form") : !0, [B, V] = c.useState(/* @__PURE__ */ new Set()), U = Array.from(B).map((L) => L.props.value).join(";");
  return /* @__PURE__ */ d(go, { ...h, children: /* @__PURE__ */ H(
    _h,
    {
      required: v,
      scope: t,
      trigger: g,
      onTriggerChange: b,
      valueNode: y,
      onValueNodeChange: S,
      valueNodeHasChildren: x,
      onValueNodeHasChildrenChange: C,
      contentId: re(),
      value: M,
      onValueChange: T,
      open: R,
      onOpenChange: A,
      dir: P,
      triggerPointerDownPosRef: O,
      disabled: m,
      children: [
        /* @__PURE__ */ d(gn.Provider, { scope: t, children: /* @__PURE__ */ d(
          Mh,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: c.useCallback((L) => {
              V((W) => new Set(W).add(L));
            }, []),
            onNativeOptionRemove: c.useCallback((L) => {
              V((W) => {
                const I = new Set(W);
                return I.delete(L), I;
              });
            }, []),
            children: n
          }
        ) }),
        F ? /* @__PURE__ */ H(
          lc,
          {
            "aria-hidden": !0,
            required: v,
            tabIndex: -1,
            name: p,
            autoComplete: f,
            value: M,
            onChange: (L) => T(L.target.value),
            disabled: m,
            form: w,
            children: [
              M === void 0 ? /* @__PURE__ */ d("option", { value: "" }) : null,
              Array.from(B)
            ]
          },
          U
        ) : null
      ]
    }
  ) });
};
Hs.displayName = We;
var Us = "SelectTrigger", Ks = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: o = !1, ...r } = e, a = bn(n), i = $e(Us, n), s = i.disabled || o, l = $(t, i.onTriggerChange), u = wn(n), p = c.useRef("touch"), [f, m, v] = dc((h) => {
      const g = u().filter((S) => !S.disabled), b = g.find((S) => S.value === i.value), y = fc(g, h, b);
      y !== void 0 && i.onValueChange(y.value);
    }), w = (h) => {
      s || (i.onOpenChange(!0), v()), h && (i.triggerPointerDownPosRef.current = {
        x: Math.round(h.pageX),
        y: Math.round(h.pageY)
      });
    };
    return /* @__PURE__ */ d(Ya, { asChild: !0, ...a, children: /* @__PURE__ */ d(
      _.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": uc(i.value) ? "" : void 0,
        ...r,
        ref: l,
        onClick: E(r.onClick, (h) => {
          h.currentTarget.focus(), p.current !== "mouse" && w(h);
        }),
        onPointerDown: E(r.onPointerDown, (h) => {
          p.current = h.pointerType;
          const g = h.target;
          g.hasPointerCapture(h.pointerId) && g.releasePointerCapture(h.pointerId), h.button === 0 && h.ctrlKey === !1 && h.pointerType === "mouse" && (w(h), h.preventDefault());
        }),
        onKeyDown: E(r.onKeyDown, (h) => {
          const g = f.current !== "";
          !(h.ctrlKey || h.altKey || h.metaKey) && h.key.length === 1 && m(h.key), !(g && h.key === " ") && Ph.includes(h.key) && (w(), h.preventDefault());
        })
      }
    ) });
  }
);
Ks.displayName = Us;
var Gs = "SelectValue", zs = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, children: a, placeholder: i = "", ...s } = e, l = $e(Gs, n), { onValueNodeHasChildrenChange: u } = l, p = a !== void 0, f = $(t, l.onValueNodeChange);
    return J(() => {
      u(p);
    }, [u, p]), /* @__PURE__ */ d(
      _.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: uc(l.value) ? /* @__PURE__ */ d(Ae, { children: i }) : a
      }
    );
  }
);
zs.displayName = Gs;
var Ih = "SelectIcon", js = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: o, ...r } = e;
    return /* @__PURE__ */ d(_.span, { "aria-hidden": !0, ...r, ref: t, children: o || "▼" });
  }
);
js.displayName = Ih;
var Dh = "SelectPortal", Ys = (e) => /* @__PURE__ */ d(un, { asChild: !0, ...e });
Ys.displayName = Dh;
var He = "SelectContent", Xs = c.forwardRef(
  (e, t) => {
    const n = $e(He, e.__scopeSelect), [o, r] = c.useState();
    if (J(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = o;
      return a ? zt.createPortal(
        /* @__PURE__ */ d(qs, { scope: e.__scopeSelect, children: /* @__PURE__ */ d(gn.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ d("div", { children: e.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ d(Zs, { ...e, ref: t });
  }
);
Xs.displayName = He;
var me = 10, [qs, Fe] = tt(He), Oh = "SelectContentImpl", kh = /* @__PURE__ */ Xe("SelectContent.RemoveScroll"), Zs = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: o = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: p,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: v,
      sticky: w,
      hideWhenDetached: h,
      avoidCollisions: g,
      //
      ...b
    } = e, y = $e(He, n), [S, x] = c.useState(null), [C, P] = c.useState(null), R = $(t, (k) => x(k)), [A, M] = c.useState(null), [T, O] = c.useState(
      null
    ), F = wn(n), [B, V] = c.useState(!1), U = c.useRef(!1);
    c.useEffect(() => {
      if (S) return wo(S);
    }, [S]), so();
    const L = c.useCallback(
      (k) => {
        const [G, ...X] = F().map((j) => j.ref.current), [K] = X.slice(-1), z = document.activeElement;
        for (const j of k)
          if (j === z || (j == null || j.scrollIntoView({ block: "nearest" }), j === G && C && (C.scrollTop = 0), j === K && C && (C.scrollTop = C.scrollHeight), j == null || j.focus(), document.activeElement !== z)) return;
      },
      [F, C]
    ), W = c.useCallback(
      () => L([A, S]),
      [L, A, S]
    );
    c.useEffect(() => {
      B && W();
    }, [B, W]);
    const { onOpenChange: I, triggerPointerDownPosRef: N } = y;
    c.useEffect(() => {
      if (S) {
        let k = { x: 0, y: 0 };
        const G = (K) => {
          var z, j;
          k = {
            x: Math.abs(Math.round(K.pageX) - (((z = N.current) == null ? void 0 : z.x) ?? 0)),
            y: Math.abs(Math.round(K.pageY) - (((j = N.current) == null ? void 0 : j.y) ?? 0))
          };
        }, X = (K) => {
          k.x <= 10 && k.y <= 10 ? K.preventDefault() : S.contains(K.target) || I(!1), document.removeEventListener("pointermove", G), N.current = null;
        };
        return N.current !== null && (document.addEventListener("pointermove", G), document.addEventListener("pointerup", X, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", G), document.removeEventListener("pointerup", X, { capture: !0 });
        };
      }
    }, [S, I, N]), c.useEffect(() => {
      const k = () => I(!1);
      return window.addEventListener("blur", k), window.addEventListener("resize", k), () => {
        window.removeEventListener("blur", k), window.removeEventListener("resize", k);
      };
    }, [I]);
    const [Y, q] = dc((k) => {
      const G = F().filter((z) => !z.disabled), X = G.find((z) => z.ref.current === document.activeElement), K = fc(G, k, X);
      K && setTimeout(() => K.ref.current.focus());
    }), oe = c.useCallback(
      (k, G, X) => {
        const K = !U.current && !X;
        (y.value !== void 0 && y.value === G || K) && (M(k), K && (U.current = !0));
      },
      [y.value]
    ), Pe = c.useCallback(() => S == null ? void 0 : S.focus(), [S]), ue = c.useCallback(
      (k, G, X) => {
        const K = !U.current && !X;
        (y.value !== void 0 && y.value === G || K) && O(k);
      },
      [y.value]
    ), Ne = o === "popper" ? Vn : Qs, ie = Ne === Vn ? {
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: p,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: v,
      sticky: w,
      hideWhenDetached: h,
      avoidCollisions: g
    } : {};
    return /* @__PURE__ */ d(
      qs,
      {
        scope: n,
        content: S,
        viewport: C,
        onViewportChange: P,
        itemRefCallback: oe,
        selectedItem: A,
        onItemLeave: Pe,
        itemTextRefCallback: ue,
        focusSelectedItem: W,
        selectedItemText: T,
        position: o,
        isPositioned: B,
        searchRef: Y,
        children: /* @__PURE__ */ d(fn, { as: kh, allowPinchZoom: !0, children: /* @__PURE__ */ d(
          on,
          {
            asChild: !0,
            trapped: y.open,
            onMountAutoFocus: (k) => {
              k.preventDefault();
            },
            onUnmountAutoFocus: E(r, (k) => {
              var G;
              (G = y.trigger) == null || G.focus({ preventScroll: !0 }), k.preventDefault();
            }),
            children: /* @__PURE__ */ d(
              nn,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: i,
                onFocusOutside: (k) => k.preventDefault(),
                onDismiss: () => y.onOpenChange(!1),
                children: /* @__PURE__ */ d(
                  Ne,
                  {
                    role: "listbox",
                    id: y.contentId,
                    "data-state": y.open ? "open" : "closed",
                    dir: y.dir,
                    onContextMenu: (k) => k.preventDefault(),
                    ...b,
                    ...ie,
                    onPlaced: () => V(!0),
                    ref: R,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: E(b.onKeyDown, (k) => {
                      const G = k.ctrlKey || k.altKey || k.metaKey;
                      if (k.key === "Tab" && k.preventDefault(), !G && k.key.length === 1 && q(k.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(k.key)) {
                        let K = F().filter((z) => !z.disabled).map((z) => z.ref.current);
                        if (["ArrowUp", "End"].includes(k.key) && (K = K.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(k.key)) {
                          const z = k.target, j = K.indexOf(z);
                          K = K.slice(j + 1);
                        }
                        setTimeout(() => L(K)), k.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Zs.displayName = Oh;
var Lh = "SelectItemAlignedPosition", Qs = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: o, ...r } = e, a = $e(He, n), i = Fe(He, n), [s, l] = c.useState(null), [u, p] = c.useState(null), f = $(t, (R) => p(R)), m = wn(n), v = c.useRef(!1), w = c.useRef(!0), { viewport: h, selectedItem: g, selectedItemText: b, focusSelectedItem: y } = i, S = c.useCallback(() => {
    if (a.trigger && a.valueNode && s && u && h && g && b) {
      const R = a.trigger.getBoundingClientRect(), A = u.getBoundingClientRect(), M = a.valueNode.getBoundingClientRect(), T = b.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const z = T.left - A.left, j = M.left - z, se = R.left - j, be = R.width + se, ot = Math.max(be, A.width), rt = window.innerWidth - me, at = ct(j, [
          me,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(me, rt - ot)
        ]);
        s.style.minWidth = be + "px", s.style.left = at + "px";
      } else {
        const z = A.right - T.right, j = window.innerWidth - M.right - z, se = window.innerWidth - R.right - j, be = R.width + se, ot = Math.max(be, A.width), rt = window.innerWidth - me, at = ct(j, [
          me,
          Math.max(me, rt - ot)
        ]);
        s.style.minWidth = be + "px", s.style.right = at + "px";
      }
      const O = m(), F = window.innerHeight - me * 2, B = h.scrollHeight, V = window.getComputedStyle(u), U = parseInt(V.borderTopWidth, 10), L = parseInt(V.paddingTop, 10), W = parseInt(V.borderBottomWidth, 10), I = parseInt(V.paddingBottom, 10), N = U + L + B + I + W, Y = Math.min(g.offsetHeight * 5, N), q = window.getComputedStyle(h), oe = parseInt(q.paddingTop, 10), Pe = parseInt(q.paddingBottom, 10), ue = R.top + R.height / 2 - me, Ne = F - ue, ie = g.offsetHeight / 2, k = g.offsetTop + ie, G = U + L + k, X = N - G;
      if (G <= ue) {
        const z = O.length > 0 && g === O[O.length - 1].ref.current;
        s.style.bottom = "0px";
        const j = u.clientHeight - h.offsetTop - h.offsetHeight, se = Math.max(
          Ne,
          ie + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (z ? Pe : 0) + j + W
        ), be = G + se;
        s.style.height = be + "px";
      } else {
        const z = O.length > 0 && g === O[0].ref.current;
        s.style.top = "0px";
        const se = Math.max(
          ue,
          U + h.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (z ? oe : 0) + ie
        ) + X;
        s.style.height = se + "px", h.scrollTop = G - ue + h.offsetTop;
      }
      s.style.margin = `${me}px 0`, s.style.minHeight = Y + "px", s.style.maxHeight = F + "px", o == null || o(), requestAnimationFrame(() => v.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    s,
    u,
    h,
    g,
    b,
    a.dir,
    o
  ]);
  J(() => S(), [S]);
  const [x, C] = c.useState();
  J(() => {
    u && C(window.getComputedStyle(u).zIndex);
  }, [u]);
  const P = c.useCallback(
    (R) => {
      R && w.current === !0 && (S(), y == null || y(), w.current = !1);
    },
    [S, y]
  );
  return /* @__PURE__ */ d(
    Fh,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: v,
      onScrollButtonChange: P,
      children: /* @__PURE__ */ d(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: x
          },
          children: /* @__PURE__ */ d(
            _.div,
            {
              ...r,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
Qs.displayName = Lh;
var $h = "SelectPopperPosition", Vn = c.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: o = "start",
    collisionPadding: r = me,
    ...a
  } = e, i = bn(n);
  return /* @__PURE__ */ d(
    Xa,
    {
      ...i,
      ...a,
      ref: t,
      align: o,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Vn.displayName = $h;
var [Fh, Oo] = tt(He, {}), Wn = "SelectViewport", Js = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: o, ...r } = e, a = Fe(Wn, n), i = Oo(Wn, n), s = $(t, a.onViewportChange), l = c.useRef(0);
    return /* @__PURE__ */ H(Ae, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ d(gn.Slot, { scope: n, children: /* @__PURE__ */ d(
        _.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: E(r.onScroll, (u) => {
            const p = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: m } = i;
            if (m != null && m.current && f) {
              const v = Math.abs(l.current - p.scrollTop);
              if (v > 0) {
                const w = window.innerHeight - me * 2, h = parseFloat(f.style.minHeight), g = parseFloat(f.style.height), b = Math.max(h, g);
                if (b < w) {
                  const y = b + v, S = Math.min(w, y), x = y - S;
                  f.style.height = S + "px", f.style.bottom === "0px" && (p.scrollTop = x > 0 ? x : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = p.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Js.displayName = Wn;
var ec = "SelectGroup", [Bh, Vh] = tt(ec), tc = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = re();
    return /* @__PURE__ */ d(Bh, { scope: n, id: r, children: /* @__PURE__ */ d(_.div, { role: "group", "aria-labelledby": r, ...o, ref: t }) });
  }
);
tc.displayName = ec;
var nc = "SelectLabel", Wh = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = Vh(nc, n);
    return /* @__PURE__ */ d(_.div, { id: r.id, ...o, ref: t });
  }
);
Wh.displayName = nc;
var Gt = "SelectItem", [Hh, oc] = tt(Gt), rc = c.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: o,
      disabled: r = !1,
      textValue: a,
      ...i
    } = e, s = $e(Gt, n), l = Fe(Gt, n), u = s.value === o, [p, f] = c.useState(a ?? ""), [m, v] = c.useState(!1), w = $(
      t,
      (y) => {
        var S;
        return (S = l.itemRefCallback) == null ? void 0 : S.call(l, y, o, r);
      }
    ), h = re(), g = c.useRef("touch"), b = () => {
      r || (s.onValueChange(o), s.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d(
      Hh,
      {
        scope: n,
        value: o,
        disabled: r,
        textId: h,
        isSelected: u,
        onItemTextChange: c.useCallback((y) => {
          f((S) => S || ((y == null ? void 0 : y.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d(
          gn.ItemSlot,
          {
            scope: n,
            value: o,
            disabled: r,
            textValue: p,
            children: /* @__PURE__ */ d(
              _.div,
              {
                role: "option",
                "aria-labelledby": h,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": u && m,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...i,
                ref: w,
                onFocus: E(i.onFocus, () => v(!0)),
                onBlur: E(i.onBlur, () => v(!1)),
                onClick: E(i.onClick, () => {
                  g.current !== "mouse" && b();
                }),
                onPointerUp: E(i.onPointerUp, () => {
                  g.current === "mouse" && b();
                }),
                onPointerDown: E(i.onPointerDown, (y) => {
                  g.current = y.pointerType;
                }),
                onPointerMove: E(i.onPointerMove, (y) => {
                  var S;
                  g.current = y.pointerType, r ? (S = l.onItemLeave) == null || S.call(l) : g.current === "mouse" && y.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: E(i.onPointerLeave, (y) => {
                  var S;
                  y.currentTarget === document.activeElement && ((S = l.onItemLeave) == null || S.call(l));
                }),
                onKeyDown: E(i.onKeyDown, (y) => {
                  var x;
                  ((x = l.searchRef) == null ? void 0 : x.current) !== "" && y.key === " " || (Nh.includes(y.key) && b(), y.key === " " && y.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
rc.displayName = Gt;
var st = "SelectItemText", ac = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: o, style: r, ...a } = e, i = $e(st, n), s = Fe(st, n), l = oc(st, n), u = Th(st, n), [p, f] = c.useState(null), m = $(
      t,
      (b) => f(b),
      l.onItemTextChange,
      (b) => {
        var y;
        return (y = s.itemTextRefCallback) == null ? void 0 : y.call(s, b, l.value, l.disabled);
      }
    ), v = p == null ? void 0 : p.textContent, w = c.useMemo(
      () => /* @__PURE__ */ d("option", { value: l.value, disabled: l.disabled, children: v }, l.value),
      [l.disabled, l.value, v]
    ), { onNativeOptionAdd: h, onNativeOptionRemove: g } = u;
    return J(() => (h(w), () => g(w)), [h, g, w]), /* @__PURE__ */ H(Ae, { children: [
      /* @__PURE__ */ d(_.span, { id: l.textId, ...a, ref: m }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? zt.createPortal(a.children, i.valueNode) : null
    ] });
  }
);
ac.displayName = st;
var ic = "SelectItemIndicator", sc = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return oc(ic, n).isSelected ? /* @__PURE__ */ d(_.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
sc.displayName = ic;
var Hn = "SelectScrollUpButton", Uh = c.forwardRef((e, t) => {
  const n = Fe(Hn, e.__scopeSelect), o = Oo(Hn, e.__scopeSelect), [r, a] = c.useState(!1), i = $(t, o.onScrollButtonChange);
  return J(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollTop > 0;
        a(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ d(
    cc,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Uh.displayName = Hn;
var Un = "SelectScrollDownButton", Kh = c.forwardRef((e, t) => {
  const n = Fe(Un, e.__scopeSelect), o = Oo(Un, e.__scopeSelect), [r, a] = c.useState(!1), i = $(t, o.onScrollButtonChange);
  return J(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollHeight - l.clientHeight, p = Math.ceil(l.scrollTop) < u;
        a(p);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ d(
    cc,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Kh.displayName = Un;
var cc = c.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: o, ...r } = e, a = Fe("SelectScrollButton", n), i = c.useRef(null), s = wn(n), l = c.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return c.useEffect(() => () => l(), [l]), J(() => {
    var p;
    const u = s().find((f) => f.ref.current === document.activeElement);
    (p = u == null ? void 0 : u.ref.current) == null || p.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ d(
    _.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: t,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: E(r.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: E(r.onPointerMove, () => {
        var u;
        (u = a.onItemLeave) == null || u.call(a), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: E(r.onPointerLeave, () => {
        l();
      })
    }
  );
}), Gh = "SelectSeparator", zh = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e;
    return /* @__PURE__ */ d(_.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
zh.displayName = Gh;
var Kn = "SelectArrow", jh = c.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...o } = e, r = bn(n), a = $e(Kn, n), i = Fe(Kn, n);
    return a.open && i.position === "popper" ? /* @__PURE__ */ d(qa, { ...r, ...o, ref: t }) : null;
  }
);
jh.displayName = Kn;
var Yh = "SelectBubbleInput", lc = c.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, o) => {
    const r = c.useRef(null), a = $(o, r), i = mt(t);
    return c.useEffect(() => {
      const s = r.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, p = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== t && p) {
        const f = new Event("change", { bubbles: !0 });
        p.call(s, t), s.dispatchEvent(f);
      }
    }, [i, t]), /* @__PURE__ */ d(
      _.select,
      {
        ...n,
        style: { ...Ws, ...n.style },
        ref: a,
        defaultValue: t
      }
    );
  }
);
lc.displayName = Yh;
function uc(e) {
  return e === "" || e === void 0;
}
function dc(e) {
  const t = Q(e), n = c.useRef(""), o = c.useRef(0), r = c.useCallback(
    (i) => {
      const s = n.current + i;
      t(s), function l(u) {
        n.current = u, window.clearTimeout(o.current), u !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), a = c.useCallback(() => {
    n.current = "", window.clearTimeout(o.current);
  }, []);
  return c.useEffect(() => () => window.clearTimeout(o.current), []), [n, r, a];
}
function fc(e, t, n) {
  const r = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let i = Xh(e, Math.max(a, 0));
  r.length === 1 && (i = i.filter((u) => u !== n));
  const l = i.find(
    (u) => u.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function Xh(e, t) {
  return e.map((n, o) => e[(t + o) % e.length]);
}
var qh = Hs, pc = Ks, Zh = zs, Qh = js, Jh = Ys, mc = Xs, ev = Js, tv = tc, hc = rc, nv = ac, ov = sc;
const Yv = qh, Xv = tv, qv = Zh, rv = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ H(
  pc,
  {
    ref: o,
    className: D(
      "flex h-10 w-full items-center justify-between rounded-md border border-gray-300 bg-white px-3 py-2 text-sm ring-offset-white placeholder:text-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
      e
    ),
    ...n,
    children: [
      t,
      /* @__PURE__ */ d(Qh, { asChild: !0, children: /* @__PURE__ */ d(xa, { className: "h-4 w-4 opacity-50" }) })
    ]
  }
));
rv.displayName = pc.displayName;
const av = c.forwardRef(({ className: e, children: t, position: n = "popper", ...o }, r) => /* @__PURE__ */ d(Jh, { children: /* @__PURE__ */ d(
  mc,
  {
    ref: r,
    className: D(
      "relative z-50 min-w-[8rem] rounded-md border bg-white text-gray-950 shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out",
      n === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
      e
    ),
    position: n,
    ...o,
    children: /* @__PURE__ */ d(
      ev,
      {
        className: D(
          "p-1",
          "overflow-y-auto overflow-x-hidden",
          "overscroll-contain",
          "[&::-webkit-scrollbar]:w-2",
          "[&::-webkit-scrollbar-thumb]:bg-gray-300",
          "[&::-webkit-scrollbar-thumb]:rounded-full",
          n === "popper" ? "max-h-[300px] w-full min-w-[var(--radix-select-trigger-width)]" : "max-h-[300px]"
        ),
        style: {
          WebkitOverflowScrolling: "touch"
        },
        children: t
      }
    )
  }
) }));
av.displayName = mc.displayName;
const iv = c.forwardRef(({ className: e, children: t, ...n }, o) => /* @__PURE__ */ H(
  hc,
  {
    ref: o,
    className: D(
      "relative flex w-full cursor-default select-none items-center rounded-sm py-1.5 pl-8 pr-2 text-sm outline-none focus:bg-gray-100 focus:text-gray-900 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      e
    ),
    ...n,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(ov, { children: /* @__PURE__ */ d(tn, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ d(nv, { children: t })
    ]
  }
));
iv.displayName = hc.displayName;
var vc = ["PageUp", "PageDown"], gc = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], wc = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, nt = "Slider", [Gn, sv, cv] = vt(nt), [bc] = ee(nt, [
  cv
]), [lv, yn] = bc(nt), yc = c.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: o = 0,
      max: r = 100,
      step: a = 1,
      orientation: i = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: u = [o],
      value: p,
      onValueChange: f = () => {
      },
      onValueCommit: m = () => {
      },
      inverted: v = !1,
      form: w,
      ...h
    } = e, g = c.useRef(/* @__PURE__ */ new Set()), b = c.useRef(0), S = i === "horizontal" ? uv : dv, [x = [], C] = ae({
      prop: p,
      defaultProp: u,
      onChange: (O) => {
        var B;
        (B = [...g.current][b.current]) == null || B.focus(), f(O);
      }
    }), P = c.useRef(x);
    function R(O) {
      const F = vv(x, O);
      T(O, F);
    }
    function A(O) {
      T(O, b.current);
    }
    function M() {
      const O = P.current[b.current];
      x[b.current] !== O && m(x);
    }
    function T(O, F, { commit: B } = { commit: !1 }) {
      const V = yv(a), U = Sv(Math.round((O - o) / a) * a + o, V), L = ct(U, [o, r]);
      C((W = []) => {
        const I = mv(W, L, F);
        if (bv(I, l * a)) {
          b.current = I.indexOf(L);
          const N = String(I) !== String(W);
          return N && B && m(I), N ? I : W;
        } else
          return W;
      });
    }
    return /* @__PURE__ */ d(
      lv,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: o,
        max: r,
        valueIndexToChangeRef: b,
        thumbs: g.current,
        values: x,
        orientation: i,
        form: w,
        children: /* @__PURE__ */ d(Gn.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ d(Gn.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ d(
          S,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...h,
            ref: t,
            onPointerDown: E(h.onPointerDown, () => {
              s || (P.current = x);
            }),
            min: o,
            max: r,
            inverted: v,
            onSlideStart: s ? void 0 : R,
            onSlideMove: s ? void 0 : A,
            onSlideEnd: s ? void 0 : M,
            onHomeKeyDown: () => !s && T(o, 0, { commit: !0 }),
            onEndKeyDown: () => !s && T(r, x.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: O, direction: F }) => {
              if (!s) {
                const U = vc.includes(O.key) || O.shiftKey && gc.includes(O.key) ? 10 : 1, L = b.current, W = x[L], I = a * U * F;
                T(W + I, L, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
yc.displayName = nt;
var [Sc, xc] = bc(nt, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), uv = c.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      dir: r,
      inverted: a,
      onSlideStart: i,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: u,
      ...p
    } = e, [f, m] = c.useState(null), v = $(t, (S) => m(S)), w = c.useRef(void 0), h = ke(r), g = h === "ltr", b = g && !a || !g && a;
    function y(S) {
      const x = w.current || f.getBoundingClientRect(), C = [0, x.width], R = ko(C, b ? [n, o] : [o, n]);
      return w.current = x, R(S - x.left);
    }
    return /* @__PURE__ */ d(
      Sc,
      {
        scope: e.__scopeSlider,
        startEdge: b ? "left" : "right",
        endEdge: b ? "right" : "left",
        direction: b ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ d(
          Cc,
          {
            dir: h,
            "data-orientation": "horizontal",
            ...p,
            ref: v,
            style: {
              ...p.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (S) => {
              const x = y(S.clientX);
              i == null || i(x);
            },
            onSlideMove: (S) => {
              const x = y(S.clientX);
              s == null || s(x);
            },
            onSlideEnd: () => {
              w.current = void 0, l == null || l();
            },
            onStepKeyDown: (S) => {
              const C = wc[b ? "from-left" : "from-right"].includes(S.key);
              u == null || u({ event: S, direction: C ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), dv = c.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: o,
      inverted: r,
      onSlideStart: a,
      onSlideMove: i,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...u
    } = e, p = c.useRef(null), f = $(t, p), m = c.useRef(void 0), v = !r;
    function w(h) {
      const g = m.current || p.current.getBoundingClientRect(), b = [0, g.height], S = ko(b, v ? [o, n] : [n, o]);
      return m.current = g, S(h - g.top);
    }
    return /* @__PURE__ */ d(
      Sc,
      {
        scope: e.__scopeSlider,
        startEdge: v ? "bottom" : "top",
        endEdge: v ? "top" : "bottom",
        size: "height",
        direction: v ? 1 : -1,
        children: /* @__PURE__ */ d(
          Cc,
          {
            "data-orientation": "vertical",
            ...u,
            ref: f,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (h) => {
              const g = w(h.clientY);
              a == null || a(g);
            },
            onSlideMove: (h) => {
              const g = w(h.clientY);
              i == null || i(g);
            },
            onSlideEnd: () => {
              m.current = void 0, s == null || s();
            },
            onStepKeyDown: (h) => {
              const b = wc[v ? "from-bottom" : "from-top"].includes(h.key);
              l == null || l({ event: h, direction: b ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Cc = c.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: o,
      onSlideMove: r,
      onSlideEnd: a,
      onHomeKeyDown: i,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...u
    } = e, p = yn(nt, n);
    return /* @__PURE__ */ d(
      _.span,
      {
        ...u,
        ref: t,
        onKeyDown: E(e.onKeyDown, (f) => {
          f.key === "Home" ? (i(f), f.preventDefault()) : f.key === "End" ? (s(f), f.preventDefault()) : vc.concat(gc).includes(f.key) && (l(f), f.preventDefault());
        }),
        onPointerDown: E(e.onPointerDown, (f) => {
          const m = f.target;
          m.setPointerCapture(f.pointerId), f.preventDefault(), p.thumbs.has(m) ? m.focus() : o(f);
        }),
        onPointerMove: E(e.onPointerMove, (f) => {
          f.target.hasPointerCapture(f.pointerId) && r(f);
        }),
        onPointerUp: E(e.onPointerUp, (f) => {
          const m = f.target;
          m.hasPointerCapture(f.pointerId) && (m.releasePointerCapture(f.pointerId), a(f));
        })
      }
    );
  }
), Rc = "SliderTrack", Ec = c.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, r = yn(Rc, n);
    return /* @__PURE__ */ d(
      _.span,
      {
        "data-disabled": r.disabled ? "" : void 0,
        "data-orientation": r.orientation,
        ...o,
        ref: t
      }
    );
  }
);
Ec.displayName = Rc;
var zn = "SliderRange", Pc = c.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...o } = e, r = yn(zn, n), a = xc(zn, n), i = c.useRef(null), s = $(t, i), l = r.values.length, u = r.values.map(
      (m) => _c(m, r.min, r.max)
    ), p = l > 1 ? Math.min(...u) : 0, f = 100 - Math.max(...u);
    return /* @__PURE__ */ d(
      _.span,
      {
        "data-orientation": r.orientation,
        "data-disabled": r.disabled ? "" : void 0,
        ...o,
        ref: s,
        style: {
          ...e.style,
          [a.startEdge]: p + "%",
          [a.endEdge]: f + "%"
        }
      }
    );
  }
);
Pc.displayName = zn;
var jn = "SliderThumb", Nc = c.forwardRef(
  (e, t) => {
    const n = sv(e.__scopeSlider), [o, r] = c.useState(null), a = $(t, (s) => r(s)), i = c.useMemo(
      () => o ? n().findIndex((s) => s.ref.current === o) : -1,
      [n, o]
    );
    return /* @__PURE__ */ d(fv, { ...e, ref: a, index: i });
  }
), fv = c.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: o, name: r, ...a } = e, i = yn(jn, n), s = xc(jn, n), [l, u] = c.useState(null), p = $(t, (y) => u(y)), f = l ? i.form || !!l.closest("form") : !0, m = ht(l), v = i.values[o], w = v === void 0 ? 0 : _c(v, i.min, i.max), h = hv(o, i.values.length), g = m == null ? void 0 : m[s.size], b = g ? gv(g, w, s.direction) : 0;
    return c.useEffect(() => {
      if (l)
        return i.thumbs.add(l), () => {
          i.thumbs.delete(l);
        };
    }, [l, i.thumbs]), /* @__PURE__ */ H(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${w}% + ${b}px)`
        },
        children: [
          /* @__PURE__ */ d(Gn.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ d(
            _.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || h,
              "aria-valuemin": i.min,
              "aria-valuenow": v,
              "aria-valuemax": i.max,
              "aria-orientation": i.orientation,
              "data-orientation": i.orientation,
              "data-disabled": i.disabled ? "" : void 0,
              tabIndex: i.disabled ? void 0 : 0,
              ...a,
              ref: p,
              style: v === void 0 ? { display: "none" } : e.style,
              onFocus: E(e.onFocus, () => {
                i.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          f && /* @__PURE__ */ d(
            Ac,
            {
              name: r ?? (i.name ? i.name + (i.values.length > 1 ? "[]" : "") : void 0),
              form: i.form,
              value: v
            },
            o
          )
        ]
      }
    );
  }
);
Nc.displayName = jn;
var pv = "RadioBubbleInput", Ac = c.forwardRef(
  ({ __scopeSlider: e, value: t, ...n }, o) => {
    const r = c.useRef(null), a = $(r, o), i = mt(t);
    return c.useEffect(() => {
      const s = r.current;
      if (!s) return;
      const l = window.HTMLInputElement.prototype, p = Object.getOwnPropertyDescriptor(l, "value").set;
      if (i !== t && p) {
        const f = new Event("input", { bubbles: !0 });
        p.call(s, t), s.dispatchEvent(f);
      }
    }, [i, t]), /* @__PURE__ */ d(
      _.input,
      {
        style: { display: "none" },
        ...n,
        ref: a,
        defaultValue: t
      }
    );
  }
);
Ac.displayName = pv;
function mv(e = [], t, n) {
  const o = [...e];
  return o[n] = t, o.sort((r, a) => r - a);
}
function _c(e, t, n) {
  const a = 100 / (n - t) * (e - t);
  return ct(a, [0, 100]);
}
function hv(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function vv(e, t) {
  if (e.length === 1) return 0;
  const n = e.map((r) => Math.abs(r - t)), o = Math.min(...n);
  return n.indexOf(o);
}
function gv(e, t, n) {
  const o = e / 2, a = ko([0, 50], [0, o]);
  return (o - a(t) * n) * n;
}
function wv(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function bv(e, t) {
  if (t > 0) {
    const n = wv(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function ko(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (n - e[0]);
  };
}
function yv(e) {
  return (String(e).split(".")[1] || "").length;
}
function Sv(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var Mc = yc, xv = Ec, Cv = Pc, Rv = Nc;
const Tc = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ H(
  Mc,
  {
    ref: n,
    className: D(
      "relative flex w-full touch-none select-none items-center h-5",
      e
    ),
    ...t,
    children: [
      /* @__PURE__ */ d(
        xv,
        {
          className: "relative h-2 w-full grow overflow-hidden rounded-full",
          style: { backgroundColor: "#d1d5db" },
          children: /* @__PURE__ */ d(
            Cv,
            {
              className: "absolute h-full rounded-full",
              style: { backgroundColor: "#3b82f6" }
            }
          )
        }
      ),
      /* @__PURE__ */ d(
        Rv,
        {
          className: "block h-5 w-5 rounded-full border-2 bg-white cursor-pointer transition-colors disabled:pointer-events-none disabled:opacity-50",
          style: {
            borderColor: "#3b82f6",
            boxShadow: "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)"
          }
        }
      )
    ]
  }
));
Tc.displayName = Mc.displayName;
function Zv({
  isLoading: e = !1,
  loadingText: t = "生成中...",
  children: n = "生成",
  className: o,
  disabled: r,
  type: a = "button",
  ...i
}) {
  return /* @__PURE__ */ d(
    xt,
    {
      type: a,
      disabled: e || r,
      className: D("min-w-[120px]", o),
      ...i,
      children: e ? /* @__PURE__ */ H(Ae, { children: [
        /* @__PURE__ */ d(Zu, { className: "mr-2 h-4 w-4 animate-spin" }),
        t
      ] }) : /* @__PURE__ */ H(Ae, { children: [
        /* @__PURE__ */ d(Ca, { className: "mr-2 h-4 w-4" }),
        n
      ] })
    }
  );
}
function Ev({
  value: e,
  onCopy: t,
  className: n,
  ...o
}) {
  const [r, a] = c.useState(!1);
  return /* @__PURE__ */ d(
    xt,
    {
      variant: "ghost",
      size: "icon",
      onClick: async () => {
        try {
          await navigator.clipboard.writeText(e), a(!0), t == null || t(e), setTimeout(() => a(!1), 2e3);
        } catch (s) {
          console.error("Failed to copy:", s);
        }
      },
      className: D("h-8 w-8", n),
      ...o,
      children: r ? /* @__PURE__ */ d(tn, { className: "h-4 w-4 text-green-600" }) : /* @__PURE__ */ d(Yu, { className: "h-4 w-4" })
    }
  );
}
function Qv({
  value: e,
  onChange: t,
  onRandomize: n,
  className: o,
  ...r
}) {
  const a = (s) => {
    const l = s.target.value;
    if (l === "")
      t == null || t(void 0);
    else {
      const u = parseInt(l, 10);
      isNaN(u) || t == null || t(u);
    }
  }, i = () => {
    const s = Math.floor(Math.random() * 1e6);
    t == null || t(s), n == null || n();
  };
  return /* @__PURE__ */ H("div", { className: "flex gap-2", children: [
    /* @__PURE__ */ d(
      Ms,
      {
        type: "number",
        value: e ?? "",
        onChange: a,
        placeholder: "シード値（空欄でランダム）",
        className: D("flex-1", o),
        ...r
      }
    ),
    /* @__PURE__ */ d(
      xt,
      {
        type: "button",
        variant: "outline",
        size: "icon",
        onClick: i,
        title: "ランダム生成",
        children: /* @__PURE__ */ d(Xu, { className: "h-4 w-4" })
      }
    )
  ] });
}
function Jv({
  value: e,
  onChange: t,
  min: n = 1,
  max: o = 10,
  label: r = "生成数",
  className: a
}) {
  const i = (s) => {
    t(s[0]);
  };
  return /* @__PURE__ */ H("div", { className: D("space-y-2", a), children: [
    /* @__PURE__ */ H("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ d(Ds, { htmlFor: "count-slider", children: r }),
      /* @__PURE__ */ d("span", { className: "text-sm font-medium", children: e })
    ] }),
    /* @__PURE__ */ d(
      Tc,
      {
        id: "count-slider",
        value: [e],
        onValueChange: i,
        min: n,
        max: o,
        step: 1,
        className: "w-full"
      }
    )
  ] });
}
var Sn = "Tabs", [Pv] = ee(Sn, [
  Qe
]), Ic = Qe(), [Nv, Lo] = Pv(Sn), Dc = c.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: n,
      value: o,
      onValueChange: r,
      defaultValue: a,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...u
    } = e, p = ke(s), [f, m] = ae({
      prop: o,
      onChange: r,
      defaultProp: a ?? "",
      caller: Sn
    });
    return /* @__PURE__ */ d(
      Nv,
      {
        scope: n,
        baseId: re(),
        value: f,
        onValueChange: m,
        orientation: i,
        dir: p,
        activationMode: l,
        children: /* @__PURE__ */ d(
          _.div,
          {
            dir: p,
            "data-orientation": i,
            ...u,
            ref: t
          }
        )
      }
    );
  }
);
Dc.displayName = Sn;
var Oc = "TabsList", kc = c.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, loop: o = !0, ...r } = e, a = Lo(Oc, n), i = Ic(n);
    return /* @__PURE__ */ d(
      Qn,
      {
        asChild: !0,
        ...i,
        orientation: a.orientation,
        dir: a.dir,
        loop: o,
        children: /* @__PURE__ */ d(
          _.div,
          {
            role: "tablist",
            "aria-orientation": a.orientation,
            ...r,
            ref: t
          }
        )
      }
    );
  }
);
kc.displayName = Oc;
var Lc = "TabsTrigger", $c = c.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, disabled: r = !1, ...a } = e, i = Lo(Lc, n), s = Ic(n), l = Vc(i.baseId, o), u = Wc(i.baseId, o), p = o === i.value;
    return /* @__PURE__ */ d(
      Jn,
      {
        asChild: !0,
        ...s,
        focusable: !r,
        active: p,
        children: /* @__PURE__ */ d(
          _.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": p,
            "aria-controls": u,
            "data-state": p ? "active" : "inactive",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            id: l,
            ...a,
            ref: t,
            onMouseDown: E(e.onMouseDown, (f) => {
              !r && f.button === 0 && f.ctrlKey === !1 ? i.onValueChange(o) : f.preventDefault();
            }),
            onKeyDown: E(e.onKeyDown, (f) => {
              [" ", "Enter"].includes(f.key) && i.onValueChange(o);
            }),
            onFocus: E(e.onFocus, () => {
              const f = i.activationMode !== "manual";
              !p && !r && f && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
$c.displayName = Lc;
var Fc = "TabsContent", Bc = c.forwardRef(
  (e, t) => {
    const { __scopeTabs: n, value: o, forceMount: r, children: a, ...i } = e, s = Lo(Fc, n), l = Vc(s.baseId, o), u = Wc(s.baseId, o), p = o === s.value, f = c.useRef(p);
    return c.useEffect(() => {
      const m = requestAnimationFrame(() => f.current = !1);
      return () => cancelAnimationFrame(m);
    }, []), /* @__PURE__ */ d(te, { present: r || p, children: ({ present: m }) => /* @__PURE__ */ d(
      _.div,
      {
        "data-state": p ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !m,
        id: u,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: f.current ? "0s" : void 0
        },
        children: m && a
      }
    ) });
  }
);
Bc.displayName = Fc;
function Vc(e, t) {
  return `${e}-trigger-${t}`;
}
function Wc(e, t) {
  return `${e}-content-${t}`;
}
var Av = Dc, Hc = kc, Uc = $c, Kc = Bc;
const eg = Av, _v = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Hc,
  {
    ref: n,
    className: D(
      "inline-flex items-center justify-center rounded-md bg-gray-100 p-1 text-gray-700",
      // h-10を削除してh-autoをデフォルトに
      "h-auto min-h-[2.5rem]",
      // モバイルでスクロール可能に
      "overflow-x-auto md:overflow-x-visible",
      e
    ),
    ...t
  }
));
_v.displayName = Hc.displayName;
const Mv = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Uc,
  {
    ref: n,
    className: D(
      "inline-flex items-center justify-center whitespace-nowrap rounded-sm",
      // モバイルでのパディングと文字サイズを調整
      "px-2 py-1 text-xs md:px-3 md:py-1.5 md:text-sm",
      "font-medium ring-offset-white transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-white data-[state=active]:text-gray-950 data-[state=active]:shadow-sm",
      // モバイルでflexを保持
      "flex-shrink-0",
      e
    ),
    ...t
  }
));
Mv.displayName = Uc.displayName;
const Tv = c.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ d(
  Kc,
  {
    ref: n,
    className: D(
      "mt-2 ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2",
      e
    ),
    ...t
  }
));
Tv.displayName = Kc.displayName;
function tg({
  title: e,
  description: t,
  children: n,
  className: o,
  ...r
}) {
  return /* @__PURE__ */ H(
    "form",
    {
      className: D("space-y-6 rounded-lg border border-gray-200 bg-white p-6", o),
      ...r,
      children: [
        (e || t) && /* @__PURE__ */ H("div", { className: "space-y-2", children: [
          e && /* @__PURE__ */ d("h2", { className: "text-2xl font-bold text-gray-900", children: e }),
          t && /* @__PURE__ */ d("p", { className: "text-sm text-gray-600", children: t })
        ] }),
        n
      ]
    }
  );
}
function ng({
  children: e,
  className: t,
  emptyMessage: n = "生成結果がありません"
}) {
  return c.Children.toArray(e).length === 0 ? /* @__PURE__ */ d("div", { className: D("rounded-lg border border-gray-200 bg-white p-8", t), children: /* @__PURE__ */ d("p", { className: "text-center text-gray-500", children: n }) }) : /* @__PURE__ */ d("div", { className: D("space-y-2", t), children: e });
}
function og({
  value: e,
  label: t,
  subtitle: n,
  isFavorite: o = !1,
  onToggleFavorite: r,
  onCopy: a,
  className: i,
  actions: s
}) {
  return /* @__PURE__ */ H(
    "div",
    {
      className: D(
        "flex items-center justify-between rounded-lg border border-gray-200 bg-white p-4 hover:border-gray-300 transition-colors",
        i
      ),
      children: [
        /* @__PURE__ */ H("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ H("div", { className: "flex items-center gap-2", children: [
            t && /* @__PURE__ */ d("span", { className: "text-xs font-medium text-gray-500", children: t }),
            /* @__PURE__ */ d("p", { className: "text-base font-medium text-gray-900 truncate", children: e })
          ] }),
          n && /* @__PURE__ */ d("p", { className: "mt-1 text-sm text-gray-600", children: n })
        ] }),
        /* @__PURE__ */ H("div", { className: "flex items-center gap-1 ml-4", children: [
          r && /* @__PURE__ */ d(
            xt,
            {
              variant: "ghost",
              size: "icon",
              onClick: r,
              className: "h-8 w-8",
              children: o ? /* @__PURE__ */ d(Ju, { className: "h-4 w-4 fill-yellow-500 text-yellow-500" }) : /* @__PURE__ */ d(Qu, { className: "h-4 w-4" })
            }
          ),
          /* @__PURE__ */ d(Ev, { value: e, onCopy: a }),
          s
        ] })
      ]
    }
  );
}
function rg({
  icon: e = "empty",
  title: t = "データがありません",
  description: n,
  action: o,
  className: r
}) {
  const a = () => {
    if (c.isValidElement(e))
      return e;
    switch (e) {
      case "sparkles":
        return /* @__PURE__ */ d(Ca, { className: "h-12 w-12 text-gray-400" });
      case "empty":
      default:
        return /* @__PURE__ */ d(qu, { className: "h-12 w-12 text-gray-400" });
    }
  };
  return /* @__PURE__ */ H(
    "div",
    {
      className: D(
        "flex flex-col items-center justify-center py-12 px-4 text-center",
        r
      ),
      children: [
        /* @__PURE__ */ d("div", { className: "mb-4", children: a() }),
        /* @__PURE__ */ d("h3", { className: "text-lg font-medium text-gray-900 mb-2", children: t }),
        n && /* @__PURE__ */ d("p", { className: "text-sm text-gray-600 mb-4 max-w-sm", children: n }),
        o && /* @__PURE__ */ d("div", { className: "mt-4", children: o })
      ]
    }
  );
}
export {
  Lv as Accordion,
  od as AccordionContent,
  td as AccordionItem,
  nd as AccordionTrigger,
  Jc as Alert,
  tl as AlertDescription,
  el as AlertTitle,
  jv as Badge,
  xt as Button,
  nl as Card,
  il as CardContent,
  al as CardDescription,
  sl as CardFooter,
  ol as CardHeader,
  rl as CardTitle,
  xh as Checkbox,
  Ev as CopyButton,
  Jv as CountSelector,
  Kv as Dialog,
  zv as DialogClose,
  nh as DialogContent,
  ih as DialogDescription,
  rh as DialogFooter,
  oh as DialogHeader,
  Rs as DialogOverlay,
  th as DialogPortal,
  ah as DialogTitle,
  Gv as DialogTrigger,
  $v as DropdownMenu,
  Fm as DropdownMenuCheckboxItem,
  Lm as DropdownMenuContent,
  Bv as DropdownMenuGroup,
  $m as DropdownMenuItem,
  Vm as DropdownMenuLabel,
  Vv as DropdownMenuPortal,
  Hv as DropdownMenuRadioGroup,
  Bm as DropdownMenuRadioItem,
  Wm as DropdownMenuSeparator,
  Hm as DropdownMenuShortcut,
  Wv as DropdownMenuSub,
  km as DropdownMenuSubContent,
  Om as DropdownMenuSubTrigger,
  Fv as DropdownMenuTrigger,
  rg as EmptyState,
  Zv as GenerateButton,
  tg as GeneratorForm,
  Ms as Input,
  Ds as Label,
  vh as Progress,
  du as RadioGroup,
  fu as RadioGroupItem,
  og as ResultItem,
  ng as ResultList,
  Hl as ScrollArea,
  kr as ScrollBar,
  Qv as SeedInput,
  Yv as Select,
  av as SelectContent,
  Xv as SelectGroup,
  iv as SelectItem,
  rv as SelectTrigger,
  qv as SelectValue,
  Eu as Separator,
  Tc as Slider,
  Rl as Switch,
  eg as Tabs,
  Tv as TabsContent,
  _v as TabsList,
  Mv as TabsTrigger,
  Ch as Textarea,
  D as cn
};
